var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E0E0E0;}\n\t.st1{display:none;}\n\t.st2{display:inline;}\n\t.st3{fill:#F5F5F5;}\n\t.st4{fill:#263238;}\n\t.st5{fill:none;stroke:#4E585D;stroke-width:5.000000e-02;stroke-miterlimit:10;}\n\t.st6{fill:#455A64;}\n\t.st7{fill:#FFBF9D;}\n\t.st8{fill:#FF9A6C;}\n\t.st9{opacity:0.3;}\n\t.st10{fill:#FFFFFF;}\n\t.st11{opacity:0.6;}\n\t.st12{fill:#5F7EFF;}\n\t.st13{fill:#5F6BFF;}\n\t.st14{fill:#5F67FF;}\n\t.st15{fill:#5F82FF;}\n\t.st16{fill:#E21E14;}\n\t.st17{fill:#F0F0F0;}\n\t.st18{fill:#E1E1E1;}\n\t.st19{fill:#ECECEC;}\n\t.st20{fill:#007CFF;}\n\t.st21{opacity:0.2;enable-background:new    ;}\n\t.st22{fill:#1A2E35;}\n\t.st23{opacity:0.1;fill:#FFFFFF;enable-background:new    ;}\n\t.st24{fill:none;stroke:#1A2E35;stroke-miterlimit:10;}\n\t.st25{fill:none;stroke:#1A2E35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st26{fill:#000321;}\n\t.st27{display:inline;fill:#000321;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292.2,62.1c0,0,0,0.1-0.1,0.2c-0.1,0.1-0.3,0.3-0.5,0.5c-0.4,0.5-1,1.1-1.8,2c-1.5,1.8-3.7,4.6-5.7,8.4 s-3.9,8.8-4.5,14.7c-0.6,5.9,0.4,12.6,3,19.3l0.1,0.2l-0.2,0.1c-6.9,2-14.1,5.3-20.7,10.2c-4.8,3.5-8.9,7.6-12.4,11.9 c-3.4,4.3-6.1,8.8-8.1,13.3l-0.1,0.1H241c-2.8-0.9-5.5-1.5-8.2-1.8c-1.3-0.2-2.6-0.3-3.9-0.4c-1.3,0-2.5-0.1-3.7,0 c-4.8,0.1-8.9,1-12.2,2s-5.8,2.1-7.5,2.9c-0.8,0.4-1.5,0.8-1.9,1c-0.2,0.1-0.4,0.2-0.5,0.3s-0.2,0.1-0.2,0.1s0,0,0.2-0.1 c0.1-0.1,0.3-0.2,0.5-0.3c0.4-0.2,1-0.6,1.9-1c1.7-0.9,4.1-2,7.5-3c3.3-1,7.5-1.9,12.3-2.1c1.2-0.1,2.4,0,3.7,0 c1.3,0.1,2.6,0.2,3.9,0.3c2.7,0.3,5.5,0.9,8.3,1.8l-0.2,0.1c2-4.5,4.7-9,8.2-13.4c3.4-4.3,7.6-8.5,12.4-12 c6.6-4.9,13.9-8.3,20.8-10.3l-0.1,0.3c-2.7-6.7-3.6-13.5-3-19.4c0.5-6,2.5-11,4.6-14.8s4.3-6.6,5.8-8.4c0.8-0.9,1.4-1.5,1.9-2 c0.2-0.2,0.4-0.4,0.5-0.5C292.1,62.1,292.2,62.1,292.2,62.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.4,62.1c0,0,0.1,0.1,0.2,0.3c0.1,0.2,0.2,0.4,0.4,0.8c0.4,0.7,0.9,1.7,1.6,3 c1.4,2.6,3.4,6.4,5.8,11.1c4.9,9.4,11.4,22.5,18.2,37.2s12.7,28.1,16.7,37.9c2,4.9,3.7,8.9,4.7,11.6c0.5,1.4,1,2.4,1.3,3.2 c0.1,0.4,0.2,0.6,0.3,0.8s0.1,0.3,0.1,0.3s-0.1-0.1-0.1-0.3c-0.1-0.2-0.2-0.5-0.4-0.8c-0.3-0.7-0.8-1.8-1.3-3.1 c-1.2-2.8-2.8-6.7-4.9-11.6c-4.1-9.8-10-23.2-16.8-37.8c-6.8-14.7-13.3-27.8-18.1-37.2c-2.4-4.7-4.4-8.5-5.7-11.2 c-0.7-1.3-1.2-2.3-1.6-3c-0.2-0.3-0.3-0.6-0.4-0.8C202.5,62.2,202.4,62.1,202.4,62.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310,62.2c0,0-0.2,0-0.6,0s-0.9,0-1.6,0c-1.4,0-3.5,0-6.2,0c-5.4,0-13.2,0-22.9,0.1 c-19.4,0-46.2,0-75.9,0.1l0.1-0.4c0.7,0.4,1.4,0.7,2.2,1.1c26.8,14,50.9,27.2,68.2,36.9c8.6,4.9,15.6,8.8,20.4,11.6 c2.4,1.4,4.3,2.5,5.5,3.2c0.6,0.4,1.1,0.6,1.4,0.8c0.3,0.2,0.5,0.3,0.5,0.3s-0.2-0.1-0.5-0.3c-0.3-0.2-0.8-0.5-1.5-0.8 c-1.3-0.7-3.2-1.8-5.6-3.1c-4.8-2.7-11.8-6.6-20.5-11.5c-17.3-9.7-41.4-22.8-68.2-36.8c-0.7-0.4-1.5-0.8-2.2-1.1L202,62h0.8 c29.7,0,56.5,0,75.9,0.1c9.7,0,17.5,0,22.9,0.1c2.7,0,4.8,0,6.2,0c0.7,0,1.2,0,1.6,0C309.8,62.2,310,62.2,310,62.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203.1,129.7c0,0,0.4-0.3,1.1-0.7c0.3-0.2,0.8-0.5,1.3-0.7c0.5-0.3,1.1-0.6,1.8-0.9s1.4-0.6,2.2-0.9 s1.7-0.6,2.6-0.8c1.9-0.5,4-0.8,6.3-1c2.3-0.1,4.4,0.1,6.3,0.4c1,0.2,1.9,0.3,2.7,0.6c0.8,0.2,1.6,0.5,2.3,0.7 s1.3,0.5,1.9,0.7c0.5,0.2,1,0.4,1.4,0.6c0.7,0.4,1.1,0.6,1.1,0.6s-0.4-0.1-1.2-0.5c-0.4-0.2-0.8-0.4-1.4-0.6 c-0.5-0.2-1.2-0.5-1.9-0.7s-1.5-0.5-2.3-0.6c-0.8-0.2-1.7-0.4-2.7-0.5c-1.9-0.3-4-0.4-6.2-0.3s-4.3,0.5-6.2,0.9 c-0.9,0.3-1.8,0.5-2.6,0.8s-1.6,0.6-2.2,0.9c-0.7,0.3-1.3,0.6-1.8,0.8s-1,0.5-1.3,0.7C203.5,129.5,203.1,129.7,203.1,129.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.9,130.4c0,0,0-0.2,0-0.5s0-0.9,0-1.5c0-1.3,0.2-3.2,0.8-5.5c0.5-2.3,1.4-5,2.9-7.7 c1.5-2.8,3.5-5.6,6.1-8.1s5.5-4.4,8.4-5.7c2.8-1.3,5.5-2.1,7.9-2.5c2.3-0.4,4.2-0.5,5.5-0.5c0.7,0,1.2,0,1.5,0s0.5,0,0.5,0.1 c0,0-0.2,0-0.5,0s-0.9,0-1.5,0c-1.3,0-3.2,0.2-5.5,0.6c-2.3,0.5-5,1.3-7.8,2.6c-2.8,1.3-5.7,3.2-8.2,5.7c-2.6,2.5-4.6,5.3-6,8 c-1.5,2.7-2.4,5.4-3,7.6c-0.6,2.3-0.8,4.2-0.9,5.5c-0.1,0.7-0.1,1.2-0.1,1.5C235.9,130.2,235.9,130.4,235.9,130.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.9,62.1c0,0-0.1,0.1-0.2,0.3c-0.2,0.2-0.3,0.6-0.6,0.9c-0.3,0.4-0.6,0.9-0.9,1.5 c-0.3,0.6-0.7,1.2-1.1,2s-0.8,1.6-1.2,2.5c-0.4,0.9-0.8,1.9-1.2,2.9c-0.7,2.1-1.3,4.5-1.7,7c-0.4,2.5-0.4,5-0.4,7.2 c0.1,1.1,0.1,2.2,0.3,3.2c0.1,1,0.3,1.9,0.4,2.7c0.1,0.8,0.3,1.6,0.5,2.2c0.1,0.7,0.3,1.2,0.4,1.7c0.1,0.4,0.2,0.8,0.3,1 c0.1,0.2,0.1,0.4,0.1,0.4s-0.1-0.1-0.2-0.3c-0.1-0.3-0.2-0.6-0.4-1c-0.2-0.4-0.3-1-0.5-1.7s-0.4-1.4-0.5-2.2 c-0.2-0.8-0.4-1.7-0.5-2.7c-0.2-1-0.2-2.1-0.3-3.2c-0.1-2.2,0-4.7,0.3-7.3c0.4-2.6,1-5,1.8-7.1c0.4-1.1,0.8-2.1,1.2-3 c0.4-0.9,0.8-1.7,1.2-2.5c0.4-0.8,0.8-1.4,1.2-2c0.3-0.6,0.7-1.1,1-1.4c0.3-0.4,0.5-0.6,0.6-0.9 C274.9,62.2,274.9,62.1,274.9,62.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.7,62.1c0,0-0.2,0.3-0.7,0.8s-1.1,1.3-1.8,2.4c-0.7,1-1.5,2.3-2.1,3.9c-0.6,1.5-1.1,3.3-1.3,5.2 c-0.4,3.8,0.4,7.3,1.3,9.7c0.4,1.2,0.9,2.1,1.2,2.7s0.5,1,0.5,1s-0.3-0.3-0.6-0.9c-0.4-0.6-0.9-1.5-1.3-2.7 c-1-2.3-1.8-5.9-1.4-9.8c0.2-2,0.7-3.8,1.3-5.3c0.7-1.6,1.5-2.9,2.2-3.9c0.8-1,1.5-1.8,2-2.3 C255.4,62.3,255.7,62.1,255.7,62.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226.3,112.7c0,0,0-0.1,0-0.4c0.1-0.3,0.1-0.7,0.2-1.1c0.1-0.5,0.2-1.1,0.4-1.7c0.2-0.7,0.4-1.4,0.7-2.3 c1.1-3.3,3.4-7.7,7.1-11.6c3.7-3.9,8-6.6,11.4-7.3c1.7-0.4,3.2-0.3,4.1-0.1c0.5,0.1,0.8,0.2,1.1,0.4c0.2,0.1,0.4,0.2,0.4,0.2 s-0.5-0.2-1.5-0.4c-0.9-0.2-2.4-0.2-4.1,0.2c-3.4,0.8-7.6,3.5-11.2,7.3c-3.7,3.8-6,8.2-7.2,11.4c-0.3,0.8-0.5,1.6-0.8,2.2 c-0.2,0.7-0.4,1.2-0.5,1.7c-0.1,0.4-0.2,0.8-0.3,1.1C226.3,112.6,226.3,112.7,226.3,112.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.8,112.4c0,0,0.3-0.2,0.8-0.5s1.3-0.6,2.4-1c1-0.4,2.3-0.8,3.7-1c1.4-0.3,3-0.4,4.7-0.4 s3.2,0.2,4.6,0.5c1.4,0.3,2.6,0.7,3.6,1.1s1.8,0.8,2.3,1.1c0.5,0.3,0.8,0.5,0.8,0.5c0,0.1-1.2-0.6-3.2-1.3 c-2-0.7-4.9-1.5-8.2-1.5s-6.2,0.7-8.2,1.3C204.1,111.9,202.9,112.5,202.8,112.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203.1,96.6c0,0,0.1-0.2,0.4-0.4c0.3-0.3,0.8-0.6,1.4-1c1.2-0.8,3-1.6,5.1-2c2.2-0.4,4.1-0.2,5.5,0.1 c0.7,0.2,1.2,0.3,1.6,0.4c0.4,0.1,0.6,0.2,0.6,0.2c0,0.1-0.9-0.2-2.2-0.4c-1.4-0.2-3.3-0.4-5.4,0c-2.1,0.4-3.9,1.2-5.1,1.9 S203.1,96.6,203.1,96.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237,78.4c0,0.1-1.3,0.3-3.4,1c-0.5,0.2-1.1,0.4-1.7,0.7c-0.6,0.2-1.2,0.6-1.8,0.9 c-1.3,0.7-2.6,1.6-3.9,2.7c-1.3,1.1-2.4,2.3-3.3,3.4c-0.4,0.6-0.9,1.1-1.2,1.7c-0.4,0.5-0.7,1.1-0.9,1.5 c-1,1.9-1.4,3.3-1.5,3.2c0,0,0.1-0.3,0.3-0.9c0.1-0.3,0.2-0.7,0.4-1.1s0.4-0.9,0.6-1.4c0.3-0.5,0.5-1,0.9-1.6 c0.3-0.6,0.7-1.1,1.2-1.7c0.9-1.2,2-2.4,3.3-3.5s2.7-2,4-2.7c0.7-0.3,1.3-0.7,1.9-0.9c0.6-0.3,1.2-0.5,1.7-0.6 c0.5-0.2,1-0.3,1.4-0.4s0.8-0.2,1.1-0.2C236.6,78.4,237,78.4,237,78.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.9,61.9c0.1,0-0.5,0.8-1.1,2.3c-0.3,0.7-0.6,1.6-0.9,2.6c-0.2,1-0.4,2.1-0.5,3.3c0,1.2,0,2.3,0.2,3.3 s0.4,1.9,0.6,2.6c0.5,1.5,1,2.3,0.9,2.3c0,0-0.2-0.2-0.4-0.6s-0.5-0.9-0.8-1.7c-0.3-0.7-0.6-1.6-0.7-2.7 c-0.2-1-0.3-2.2-0.2-3.4c0.1-1.2,0.3-2.3,0.5-3.4c0.3-1,0.6-1.9,1-2.6c0.3-0.7,0.7-1.3,0.9-1.6 C237.7,62.1,237.8,61.9,237.9,61.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.8,62.2c0.1,0,0.2,24.7,0.2,55.2s-0.1,55.2-0.2,55.2s-0.2-24.7-0.2-55.2S202.7,62.2,202.8,62.2z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.2,264.1c0,0,0,0,0.1,0.1s0.2,0.2,0.4,0.3c0.3,0.3,0.8,0.8,1.5,1.3c1.4,1.1,3.4,2.7,6.3,4.3 c2.9,1.5,6.6,2.9,11,3.3c4.4,0.5,9.4-0.3,14.4-2.3l0.1-0.1v0.2c1.5,5.2,4,10.6,7.6,15.5c2.6,3.6,5.7,6.7,8.9,9.2 c3.2,2.6,6.6,4.6,9.9,6.1h0.1v0.1c-0.7,2.1-1.1,4.1-1.4,6.1c-0.1,1-0.2,2-0.3,2.9c0,0.9-0.1,1.9,0,2.8 c0.1,3.6,0.7,6.7,1.5,9.1c0.7,2.5,1.6,4.3,2.2,5.6c0.3,0.6,0.6,1.1,0.7,1.4c0.1,0.2,0.1,0.3,0.2,0.4c0,0.1,0.1,0.1,0.1,0.1 s0,0-0.1-0.1s-0.1-0.2-0.2-0.4c-0.2-0.3-0.5-0.8-0.8-1.4c-0.6-1.2-1.5-3.1-2.3-5.6s-1.4-5.6-1.5-9.2c-0.1-0.9,0-1.8,0-2.8 c0.1-1,0.1-1.9,0.3-2.9c0.3-2,0.7-4.1,1.4-6.2l0.1,0.2c-3.3-1.5-6.8-3.5-10-6.1s-6.3-5.7-9-9.3c-3.7-4.9-6.2-10.4-7.7-15.6 l0.2,0.1c-5,2-10.1,2.7-14.5,2.2c-4.5-0.4-8.2-1.9-11.1-3.4c-2.9-1.6-4.9-3.2-6.3-4.3c-0.7-0.6-1.1-1.1-1.5-1.4 c-0.2-0.2-0.3-0.3-0.4-0.4C475.3,264.1,475.2,264.1,475.2,264.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.2,331.2c0,0,0.1,0,0.2-0.1s0.3-0.2,0.6-0.3c0.5-0.3,1.3-0.7,2.2-1.2c2-1.1,4.8-2.5,8.3-4.4 c7-3.6,16.8-8.5,27.8-13.6c11-5.1,21-9.5,28.3-12.5c3.7-1.5,6.6-2.7,8.7-3.5c1-0.4,1.8-0.7,2.4-0.9c0.3-0.1,0.5-0.2,0.6-0.2 c0.1-0.1,0.2-0.1,0.2-0.1s-0.1,0-0.2,0.1c-0.2,0.1-0.4,0.2-0.6,0.3c-0.6,0.2-1.3,0.6-2.4,1c-2.1,0.9-5,2.1-8.7,3.6 c-7.3,3.1-17.3,7.5-28.3,12.6s-20.8,10-27.8,13.6c-3.5,1.8-6.4,3.3-8.4,4.3c-1,0.5-1.7,0.9-2.3,1.2c-0.3,0.1-0.4,0.2-0.6,0.3 C475.3,331.1,475.2,331.2,475.2,331.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.3,250.7c0,0,0,0.1,0,0.4c0,0.3,0,0.7,0,1.2c0,1.1,0,2.6,0,4.7c0,4.1,0,9.9,0,17.1 c0,14.5,0,34.5,0,56.7l-0.3-0.1c0.3-0.5,0.6-1.1,0.8-1.6c10.5-20.1,20.4-38,27.6-51c3.6-6.5,6.6-11.7,8.7-15.3 c1-1.8,1.8-3.2,2.4-4.1c0.3-0.5,0.5-0.8,0.6-1.1c0.1-0.2,0.2-0.4,0.2-0.4s-0.1,0.1-0.2,0.4c-0.1,0.3-0.3,0.6-0.6,1.1 c-0.5,1-1.3,2.4-2.3,4.2c-2,3.6-5,8.9-8.6,15.3c-7.2,13-17,30.9-27.5,51c-0.3,0.6-0.6,1.1-0.8,1.6l-0.3,0.5v-0.6 c0-22.2,0-42.3,0-56.7c0-7.2,0-13.1,0-17.1c0-2,0-3.6,0-4.7c0-0.5,0-0.9,0-1.2C475.3,250.9,475.3,250.7,475.3,250.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M525.8,330.7c0,0-0.2-0.3-0.5-0.8c-0.2-0.3-0.4-0.6-0.6-1c-0.2-0.4-0.5-0.8-0.7-1.3s-0.5-1.1-0.7-1.7 s-0.4-1.3-0.6-2c-0.4-1.4-0.6-3-0.7-4.7c-0.1-1.7,0.1-3.3,0.3-4.7c0.1-0.7,0.3-1.4,0.4-2c0.1-0.6,0.3-1.2,0.5-1.7 s0.4-1,0.5-1.4c0.2-0.4,0.3-0.7,0.5-1c0.3-0.5,0.4-0.8,0.5-0.8c0,0-0.1,0.3-0.3,0.9c-0.1,0.3-0.3,0.6-0.4,1 c-0.1,0.4-0.3,0.9-0.5,1.4s-0.3,1.1-0.5,1.7s-0.3,1.3-0.4,2c-0.2,1.4-0.3,3-0.3,4.7c0.1,1.7,0.4,3.2,0.7,4.6 c0.2,0.7,0.4,1.4,0.6,2c0.2,0.6,0.4,1.2,0.6,1.7c0.2,0.5,0.4,0.9,0.6,1.3c0.2,0.4,0.4,0.7,0.5,1 C525.7,330.4,525.8,330.7,525.8,330.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M526.3,306.2c0,0-0.1,0-0.4,0c-0.3,0-0.6,0-1.1,0c-1,0-2.4-0.2-4.1-0.6c-1.7-0.4-3.7-1.1-5.8-2.2 s-4.2-2.6-6-4.6c-1.9-2-3.3-4.1-4.3-6.3c-1-2.1-1.6-4.1-1.9-5.9c-0.3-1.7-0.4-3.2-0.4-4.2c0-0.5,0-0.9,0-1.1 c0-0.3,0-0.4,0-0.4s0,0.1,0,0.4s0,0.6,0,1.1c0,1,0.1,2.4,0.5,4.1c0.3,1.7,0.9,3.7,1.9,5.8c1,2.1,2.4,4.2,4.2,6.2 c1.8,1.9,3.9,3.4,6,4.5c2,1.1,4,1.8,5.7,2.2c1.7,0.4,3.1,0.6,4.1,0.7c0.5,0.1,0.9,0,1.1,0.1 C526.2,306.1,526.3,306.2,526.3,306.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.2,276.9c0,0,0.1,0,0.3,0.1c0.2,0.1,0.4,0.3,0.7,0.4c0.3,0.2,0.7,0.4,1.1,0.7 c0.4,0.2,0.9,0.6,1.5,0.8c0.6,0.3,1.2,0.6,1.9,0.9c0.7,0.3,1.4,0.6,2.2,0.9c1.6,0.5,3.4,1,5.3,1.3s3.7,0.3,5.4,0.3 c0.8,0,1.6-0.1,2.4-0.2c0.7-0.1,1.4-0.2,2-0.3c0.6-0.1,1.2-0.3,1.7-0.4s0.9-0.2,1.2-0.3c0.3-0.1,0.6-0.2,0.8-0.2 c0.2,0,0.3-0.1,0.3-0.1s-0.1,0-0.3,0.1c-0.2,0.1-0.5,0.2-0.8,0.3c-0.3,0.1-0.7,0.3-1.2,0.4s-1,0.3-1.7,0.4 c-0.6,0.1-1.3,0.3-2,0.4s-1.5,0.2-2.4,0.2c-1.7,0.1-3.5,0-5.5-0.2c-1.9-0.3-3.7-0.8-5.3-1.3c-0.8-0.3-1.5-0.6-2.2-0.9 s-1.3-0.6-1.9-0.9s-1-0.6-1.5-0.9c-0.4-0.3-0.8-0.5-1.1-0.7c-0.3-0.2-0.5-0.4-0.7-0.5C475.3,277,475.2,276.9,475.2,276.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.2,291.3c0,0,0.2,0.2,0.6,0.5s1,0.8,1.8,1.4c0.8,0.5,1.7,1.1,2.9,1.6c1.2,0.5,2.5,0.8,3.9,0.9 c2.9,0.3,5.5-0.3,7.2-1c0.9-0.3,1.6-0.7,2-0.9c0.5-0.2,0.7-0.4,0.7-0.4s-0.2,0.2-0.7,0.5s-1.1,0.6-2,1 c-1.8,0.7-4.4,1.4-7.3,1.1c-1.5-0.1-2.8-0.5-4-1s-2.1-1.1-2.9-1.7s-1.3-1.1-1.7-1.5C475.4,291.5,475.2,291.3,475.2,291.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M513.1,313.3c0,0-0.1,0-0.3,0s-0.5-0.1-0.8-0.1c-0.4-0.1-0.8-0.2-1.3-0.3c-0.5-0.2-1.1-0.3-1.7-0.5 c-2.5-0.9-5.8-2.6-8.7-5.3c-2.9-2.8-4.9-5.9-5.5-8.6c-0.3-1.3-0.2-2.4,0-3.1c0.1-0.4,0.2-0.6,0.3-0.8c0.1-0.2,0.1-0.3,0.1-0.3 s-0.1,0.4-0.3,1.1c-0.1,0.7-0.2,1.8,0.1,3c0.6,2.5,2.6,5.6,5.5,8.4s6.1,4.5,8.5,5.4c0.6,0.2,1.2,0.4,1.7,0.6 c0.5,0.1,0.9,0.3,1.3,0.4c0.3,0.1,0.6,0.1,0.8,0.2C513,313.3,513.1,313.3,513.1,313.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512.9,330.9c0,0-0.1-0.2-0.4-0.6c-0.2-0.4-0.5-1-0.8-1.8s-0.6-1.7-0.8-2.7c-0.2-1.1-0.3-2.2-0.3-3.5 c0-1.2,0.2-2.4,0.4-3.5c0.2-1.1,0.5-2,0.8-2.7c0.3-0.8,0.6-1.3,0.8-1.7c0.2-0.4,0.3-0.6,0.4-0.6c0.1,0-0.4,0.9-1,2.4 c-0.5,1.5-1.1,3.7-1.1,6.1c0,2.5,0.5,4.6,1,6.2C512.5,329.9,512.9,330.8,512.9,330.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M501,330.7c0,0-0.1-0.1-0.3-0.3c-0.2-0.2-0.5-0.6-0.7-1c-0.6-0.9-1.2-2.2-1.5-3.8 c-0.3-1.6-0.2-3.1,0.1-4.1c0.1-0.5,0.2-0.9,0.3-1.2c0.1-0.3,0.2-0.4,0.2-0.4s-0.1,0.6-0.3,1.7c-0.2,1-0.3,2.5,0,4 c0.3,1.6,0.9,2.9,1.4,3.8C500.7,330.1,501.1,330.6,501,330.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M487.4,305.3c0.1,0,0.2,1,0.7,2.6c0.1,0.4,0.3,0.8,0.5,1.2c0.2,0.4,0.4,0.9,0.7,1.4 c0.5,0.9,1.2,1.9,2,2.9c0.8,0.9,1.7,1.8,2.5,2.4c0.4,0.3,0.8,0.6,1.3,0.9c0.4,0.3,0.8,0.5,1.2,0.7c1.4,0.8,2.4,1.1,2.4,1.1 s-0.3,0-0.7-0.2c-0.2-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.7-0.3-1-0.5c-0.4-0.2-0.8-0.4-1.2-0.7c-0.4-0.2-0.8-0.6-1.3-0.9 c-0.9-0.7-1.8-1.5-2.6-2.5c-0.8-1-1.5-2-2-3c-0.2-0.5-0.5-1-0.7-1.4s-0.3-0.9-0.5-1.3c-0.1-0.4-0.2-0.8-0.3-1.1 c-0.1-0.3-0.1-0.6-0.2-0.8C487.5,305.6,487.4,305.3,487.4,305.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.1,304.7c0,0,0.6,0.4,1.7,0.8c0.5,0.2,1.2,0.5,1.9,0.7c0.7,0.2,1.6,0.3,2.5,0.4c0.9,0,1.7,0,2.5-0.1 s1.4-0.3,2-0.5c1.1-0.4,1.7-0.7,1.8-0.7c0,0-0.1,0.1-0.4,0.3c-0.3,0.2-0.7,0.4-1.3,0.6c-0.5,0.2-1.2,0.4-2,0.6 c-0.8,0.1-1.6,0.2-2.5,0.2s-1.8-0.2-2.5-0.4c-0.8-0.2-1.4-0.5-1.9-0.7c-0.5-0.3-0.9-0.5-1.2-0.7 C475.2,304.8,475.1,304.7,475.1,304.7z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.3,330.9c0-0.1,18.5-0.1,41.3-0.1s41.3,0.1,41.3,0.1s-18.5,0.1-41.3,0.1S475.3,330.9,475.3,330.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M584,61.2c0,0,0.6,0,1.5-0.4c0.5-0.2,1-0.6,1.4-1.2c0.5-0.6,0.8-1.4,0.7-2.4c0-2,0-4.4,0-7.1 c0-1.4,0-2.9,0-4.5c0-0.8,0-1.6,0-2.4c-0.1-0.8-0.5-1.6-1.1-2.1c-0.6-0.6-1.4-0.9-2.3-1c-0.9,0-1.8,0-2.8,0c-1.9,0-3.9,0-6,0 c-4.1,0-8.5,0-13.2,0c-9.3,0-19.5,0-30.2,0c-1.3,0-2.5,0.7-3.1,1.8c-0.3,0.5-0.5,1.1-0.5,1.8s0,1.3,0,2c0,2.6,0,5.2,0,7.7 c0,1.3,0,2.5,0,3.7c-0.1,1.2,0.4,2.3,1.3,3c0.4,0.3,1,0.6,1.5,0.7c0.5,0.1,1.1,0.1,1.7,0.1c1.2,0,2.4,0,3.5,0 c9.3,0,17.6,0,24.6,0.1c7,0,12.7,0.1,16.6,0.1c1.9,0,3.5,0,4.5,0c0.5,0,0.9,0,1.2,0C583.8,61.2,584,61.2,584,61.2s-0.1,0-0.4,0 c-0.3,0-0.7,0-1.2,0c-1.1,0-2.6,0-4.5,0c-3.9,0-9.6,0-16.6,0.1c-7,0-15.4,0-24.6,0.1c-1.2,0-2.3,0-3.5,0c-0.6,0-1.2,0-1.8-0.1 s-1.2-0.4-1.7-0.8c-1-0.8-1.6-2.1-1.5-3.4c0-1.2,0-2.5,0-3.7c0-2.5,0-5.1,0-7.7c0-0.7,0-1.3,0-2s0.2-1.4,0.5-2 c0.7-1.2,2.1-2.1,3.5-2c10.7,0,20.9,0,30.2,0c4.6,0,9,0,13.2,0c2.1,0,4.1,0,6,0c1,0,1.9,0,2.8,0c1,0,1.9,0.4,2.5,1.1 c0.7,0.6,1.1,1.5,1.2,2.4c0.1,0.9,0,1.7,0,2.5c0,1.6,0,3.1,0,4.5c0,2.8,0,5.2,0,7.1c0,1-0.3,1.9-0.8,2.5s-1,1-1.5,1.2 s-0.9,0.3-1.1,0.3C584.1,61.2,584,61.2,584,61.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.5,50.4c0,0,0.6,0,1.5-0.4c0.5-0.2,1-0.6,1.4-1.2c0.5-0.6,0.8-1.4,0.7-2.4c0-2,0-4.4,0-7.1 c0-1.4,0-2.9,0-4.5c0-0.8,0-1.6,0-2.4c-0.1-0.8-0.5-1.6-1.1-2.1c-0.6-0.6-1.4-0.9-2.3-1c-0.9,0-1.8,0-2.8,0c-1.9,0-3.9,0-6,0 c-4.1,0-8.5,0-13.2,0c-9.3,0-19.5,0-30.2,0c-1.3,0-2.5,0.7-3.1,1.8c-0.3,0.5-0.5,1.1-0.5,1.8s0,1.3,0,2c0,2.6,0,5.2,0,7.7 c0,1.3,0,2.5,0,3.7c-0.1,1.2,0.4,2.3,1.3,3c0.4,0.3,1,0.6,1.5,0.7c0.5,0.1,1.1,0.1,1.7,0.1c1.2,0,2.4,0,3.5,0 c9.3,0,17.6,0,24.6,0.1c7,0,12.7,0.1,16.6,0.1c1.9,0,3.5,0,4.5,0c0.5,0,0.9,0,1.2,0C118.3,50.4,118.5,50.4,118.5,50.4 s-0.1,0-0.4,0s-0.7,0-1.2,0c-1.1,0-2.6,0-4.5,0c-3.9,0-9.6,0-16.6,0.1c-7,0-15.4,0-24.6,0.1c-1.2,0-2.3,0-3.5,0 c-0.6,0-1.2,0-1.8-0.1c-0.6-0.1-1.2-0.4-1.7-0.8c-1-0.8-1.6-2.1-1.5-3.4c0-1.2,0-2.5,0-3.7c0-2.5,0-5.1,0-7.7c0-0.7,0-1.3,0-2 s0.2-1.4,0.5-2c0.7-1.2,2.1-2.1,3.5-2c10.7,0,20.9,0,30.2,0c4.6,0,9,0,13.2,0c2.1,0,4.1,0,6,0c1,0,1.9,0,2.8,0 c1,0,1.9,0.4,2.5,1.1c0.7,0.6,1.1,1.5,1.2,2.4c0.1,0.9,0,1.7,0,2.5c0,1.6,0,3.1,0,4.5c0,2.8,0,5.2,0,7.1c0,1-0.3,1.9-0.8,2.5 s-1,1-1.5,1.2s-0.9,0.3-1.1,0.3C118.6,50.4,118.5,50.4,118.5,50.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.1,71.8c0,0,0.6,0,1.5-0.4c0.5-0.2,1-0.6,1.4-1.2c0.5-0.6,0.8-1.4,0.7-2.4c0-2,0-4.4,0-7.1 c0-1.4,0-2.9,0-4.5c0-0.8,0-1.6,0-2.4c-0.1-0.8-0.5-1.6-1.1-2.1c-0.6-0.6-1.4-0.9-2.3-1c-0.9,0-1.8,0-2.8,0c-1.9,0-3.9,0-6,0 c-4.1,0-8.5,0-13.2,0c-9.3,0-19.5,0-30.2,0c-1.3,0-2.5,0.7-3.1,1.8c-0.3,0.5-0.5,1.1-0.5,1.8s0,1.3,0,2c0,2.6,0,5.2,0,7.7 c0,1.3,0,2.5,0,3.7c-0.1,1.2,0.4,2.3,1.3,3c0.4,0.3,1,0.6,1.5,0.7s1.1,0.1,1.7,0.1c1.2,0,2.4,0,3.5,0c9.3,0,17.6,0,24.6,0.1 c7,0,12.7,0.1,16.6,0.1c1.9,0,3.5,0,4.5,0c0.5,0,0.9,0,1.2,0C96.9,71.8,97.1,71.8,97.1,71.8s-0.1,0-0.4,0s-0.7,0-1.2,0 c-1.1,0-2.6,0-4.5,0c-3.9,0-9.6,0-16.6,0.1c-7,0-15.4,0-24.6,0.1c-1.2,0-2.3,0-3.5,0c-0.6,0-1.2,0-1.8-0.1s-1.2-0.4-1.7-0.8 c-1-0.8-1.6-2.1-1.5-3.4c0-1.2,0-2.5,0-3.7c0-2.5,0-5.1,0-7.7c0-0.7,0-1.3,0-2s0.2-1.4,0.5-2c0.7-1.2,2.1-2.1,3.5-2 c10.7,0,20.9,0,30.2,0c4.6,0,9,0,13.2,0c2.1,0,4.1,0,6,0c1,0,1.9,0,2.8,0c1,0,1.9,0.4,2.5,1.1c0.7,0.6,1.1,1.5,1.2,2.4 s0,1.7,0,2.5c0,1.6,0,3.1,0,4.5c0,2.8,0,5.2,0,7.1c0,1-0.3,1.9-0.8,2.5s-1,1-1.5,1.2s-0.9,0.3-1.1,0.3 C97.2,71.8,97.1,71.8,97.1,71.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M685.6,291.7c0,0,0.6,0,1.5-0.4c0.5-0.2,1-0.6,1.4-1.2c0.5-0.6,0.8-1.4,0.7-2.4c0-2,0-4.4,0-7.1 c0-1.4,0-2.9,0-4.5c0-0.8,0-1.6,0-2.4c-0.1-0.8-0.5-1.6-1.1-2.1c-0.6-0.6-1.4-0.9-2.3-1c-0.9,0-1.8,0-2.8,0c-1.9,0-3.9,0-6,0 c-4.1,0-8.5,0-13.2,0c-9.3,0-19.5,0-30.2,0c-1.3,0-2.5,0.7-3.1,1.8c-0.3,0.5-0.5,1.1-0.5,1.8c0,0.7,0,1.3,0,2c0,2.6,0,5.2,0,7.7 c0,1.3,0,2.5,0,3.7c-0.1,1.2,0.4,2.3,1.3,3c0.4,0.3,1,0.6,1.5,0.7s1.1,0.1,1.7,0.1c1.2,0,2.4,0,3.5,0c9.3,0,17.6,0,24.6,0.1 c7,0,12.7,0.1,16.6,0.1c1.9,0,3.5,0,4.5,0c0.5,0,0.9,0,1.2,0C685.5,291.6,685.6,291.7,685.6,291.7s-0.1,0-0.4,0 c-0.3,0-0.7,0-1.2,0c-1.1,0-2.6,0-4.5,0c-3.9,0-9.6,0-16.6,0.1c-7,0-15.4,0-24.6,0.1c-1.2,0-2.3,0-3.5,0c-0.6,0-1.2,0-1.8-0.1 s-1.2-0.4-1.7-0.8c-1-0.8-1.6-2.1-1.5-3.4c0-1.2,0-2.5,0-3.7c0-2.5,0-5.1,0-7.7c0-0.7,0-1.3,0-2s0.2-1.4,0.5-2 c0.7-1.2,2.1-2.1,3.5-2c10.7,0,20.9,0,30.2,0c4.6,0,9,0,13.2,0c2.1,0,4.1,0,6,0c1,0,1.9,0,2.8,0c1,0,1.9,0.4,2.5,1.1 c0.7,0.6,1.1,1.5,1.2,2.4c0.1,0.9,0,1.7,0,2.5c0,1.6,0,3.1,0,4.5c0,2.8,0,5.2,0,7.1c0,1-0.3,1.9-0.8,2.5s-1,1-1.5,1.2 s-0.9,0.3-1.1,0.3C685.8,291.7,685.6,291.7,685.6,291.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M491.6,140.6c0,0,0.6,0,1.5-0.4c0.5-0.2,1-0.6,1.4-1.2c0.5-0.6,0.8-1.4,0.7-2.4c0-2,0-4.4,0-7.1 c0-1.4,0-2.9,0-4.5c0-0.8,0-1.6,0-2.4c-0.1-0.8-0.5-1.6-1.1-2.1c-0.6-0.6-1.4-0.9-2.3-1c-0.9,0-1.8,0-2.8,0c-1.9,0-3.9,0-6,0 c-4.1,0-8.5,0-13.2,0c-9.3,0-19.5,0-30.2,0c-1.3,0-2.5,0.7-3.1,1.8c-0.3,0.5-0.5,1.1-0.5,1.8c0,0.7,0,1.3,0,2c0,2.6,0,5.2,0,7.7 c0,1.3,0,2.5,0,3.7c-0.1,1.2,0.4,2.3,1.3,3c0.4,0.3,1,0.6,1.5,0.7c0.5,0.1,1.1,0.1,1.7,0.1c1.2,0,2.4,0,3.5,0 c9.3,0,17.6,0,24.6,0.1c7,0,12.7,0.1,16.6,0.1c1.9,0,3.5,0,4.5,0c0.5,0,0.9,0,1.2,0C491.5,140.6,491.6,140.6,491.6,140.6 s-0.1,0-0.4,0s-0.7,0-1.2,0c-1.1,0-2.6,0-4.5,0c-3.9,0-9.6,0-16.6,0.1c-7,0-15.4,0-24.6,0.1c-1.2,0-2.3,0-3.5,0 c-0.6,0-1.2,0-1.8-0.1c-0.6-0.1-1.2-0.4-1.7-0.8c-1-0.8-1.6-2.1-1.5-3.4c0-1.2,0-2.5,0-3.7c0-2.5,0-5.1,0-7.7c0-0.7,0-1.3,0-2 s0.2-1.4,0.5-2c0.7-1.2,2.1-2.1,3.5-2c10.7,0,20.9,0,30.2,0c4.6,0,9,0,13.2,0c2.1,0,4.1,0,6,0c1,0,1.9,0,2.8,0 c1,0,1.9,0.4,2.5,1.1c0.7,0.6,1.1,1.5,1.2,2.4s0,1.7,0,2.5c0,1.6,0,3.1,0,4.5c0,2.8,0,5.2,0,7.1c0,1-0.3,1.9-0.8,2.5 s-1,1-1.5,1.2s-0.9,0.3-1.1,0.3C491.7,140.6,491.6,140.6,491.6,140.6z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M415.5,143.7l-1.2-2c-10.3-17-28.9-27.2-48.5-26c-2.5,0.2-5,0.5-7.5,1c-17.8,3.8-33.4,17.3-39.8,34.6 c-3.8,10.2-4.8,21.9-12,29.9c-9.4,10.5-25.2,10.8-39.2,10.4c-14-0.4-29.8-0.1-39.1,10.5c-5.8,6.6-7.7,16-7.2,24.8 c1.2,23.4,17.6,44.3,38.3,54.8c20.7,10.4,45.2,11.3,67.9,6.8c31.8-6.4,62.1-24,80.2-51.2C425.4,210.1,430,173,415.5,143.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M529.9,68.5v1.3c0.2,11.1,6.4,21.3,16.3,26.2c1.3,0.6,2.6,1.2,3.9,1.6c9.7,3.1,21.1,0.9,29-5.6 c4.7-3.9,8.5-9.3,14.2-11.2c7.5-2.5,15.3,1.8,21.9,5.9c6.7,4.1,14.5,8.4,21.9,5.9c4.7-1.6,8.2-5.6,10.5-10 c6-11.7,3.9-26.5-3.3-37.3c-7.2-10.9-18.8-18.2-31.1-22.3c-17.2-5.8-36.9-5.7-53.3,2.4C543.7,33.5,531.1,50.2,529.9,68.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 99.7,
    cy: 93.4,
    rx: 35.7,
    ry: 35.7
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M698.9,390.4c0,0.1-145,0.3-323.9,0.3s-324-0.1-324-0.3c0-0.1,145-0.3,324-0.3 C553.9,390.2,698.9,390.3,698.9,390.4z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Piping"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.8,176.5c39.7,0,108.5,0,148.2,0c5.5,0,11.1,0,16.6,0c4.4,0,8.2-3.7,8.2-8.2c0-32.2,0-64.3,0-96.5 c0-4.6,0-9.2,0-13.8c-2.7,2.7-5.5,5.5-8.2,8.2c30.6,0,61.3,0,91.9,0c48.4,0,96.9,0,145.3,0c11.1,0,22.2,0,33.3,0 c-2.7-2.7-5.5-5.5-8.2-8.2c0,31.6,0,63.2,0,94.8c0,50.4,0,100.7,0,151.1c0,11.6,0,23.1,0,34.7c0,4.4,3.7,8.2,8.2,8.2 c23.4,0,46.8,0,70.2,0c37.2,0,74.3,0,111.5,0c8.6,0,62.9-0.3,71.5-0.3c10.5,0,10.5-16.4,0-16.4c-23.4,0-92.6,0.3-116,0.3 c-37.2,0-74.3,0-111.5,0c-8.6,0-17.2,0-25.7,0c2.7,2.7,5.5,5.5,8.2,8.2c0-31.6,0-63.2,0-94.8c0-50.4,0-100.7,0-151.1 c0-11.6,0-23.1,0-34.7c0-4.4-3.7-8.2-8.2-8.2c-30.6,0-61.3,0-91.9,0c-48.4,0-96.9,0-145.3,0c-11.1,0-22.2,0-33.3,0 c-4.4,0-8.2,3.7-8.2,8.2c0,32.2,0,64.3,0,96.5c0,4.6,0,9.2,0,13.8c2.7-2.7,5.5-5.5,8.2-8.2c-39.7,0-79.4,0-119,0 c-5.5,0-40.2,0-45.8,0C20.2,160.1,20.2,176.5,30.8,176.5L30.8,176.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M203.9,66.7c-0.1,0-0.3-1.2-1-3.1c-0.4-0.9-0.9-2-1.6-3.1c-0.7-1.1-1.6-2.3-2.6-3.4c-1.1-1.1-2.2-2-3.3-2.8 c-1.1-0.7-2.1-1.3-3.1-1.7c-1.8-0.8-3.1-1.1-3-1.2c0,0,0.3,0,0.9,0.1c0.3,0.1,0.6,0.1,1,0.3c0.4,0.1,0.8,0.3,1.3,0.5 c1,0.4,2,0.9,3.2,1.7c1.1,0.8,2.3,1.7,3.4,2.8c1.1,1.1,1.9,2.4,2.6,3.5c0.7,1.2,1.2,2.3,1.5,3.3c0.2,0.5,0.3,0.9,0.4,1.3 c0.1,0.4,0.2,0.7,0.2,1C203.9,66.4,204,66.7,203.9,66.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M187.2,160"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 185.2,
    y: 142.5,
    className: "st0",
    width: 20.7,
    height: 7.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M206,149.7c0,0.1-4.6,0.3-10.3,0.3s-10.3-0.1-10.3-0.3c0-0.1,4.6-0.3,10.3-0.3 C201.4,149.5,206,149.6,206,149.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M206,142.5c0,0.1-4.6,0.3-10.4,0.3c-5.7,0-10.4-0.1-10.4-0.3c0-0.1,4.6-0.3,10.4-0.3 C201.3,142.2,206,142.3,206,142.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 445.9,
    y: 47.7,
    className: "st0",
    width: 7.3,
    height: 20.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M453.2,47.6c0.1,0,0.3,4.6,0.3,10.3s-0.1,10.3-0.3,10.3c-0.1,0-0.3-4.6-0.3-10.3 C452.9,52.2,453,47.6,453.2,47.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M445.9,47.6c0.1,0,0.3,4.6,0.3,10.4c0,5.7-0.1,10.4-0.3,10.4c-0.1,0-0.3-4.6-0.3-10.4 C445.6,52.3,445.8,47.6,445.9,47.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 455.5,
    y: 82.7,
    className: "st0",
    width: 20.7,
    height: 7.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M455.4,82.8c0-0.1,4.6-0.3,10.3-0.3c5.7,0,10.3,0.1,10.3,0.3c0,0.1-4.6,0.3-10.3,0.3 C460,83.1,455.4,82.9,455.4,82.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M455.4,90.1c0-0.1,4.6-0.3,10.4-0.3c5.7,0,10.4,0.1,10.4,0.3c0,0.1-4.6,0.3-10.4,0.3 C460.1,90.3,455.4,90.2,455.4,90.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 490.7,
    y: 326.9,
    className: "st0",
    width: 7.3,
    height: 20.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M490.7,347.7c-0.1,0-0.3-4.6-0.3-10.3c0-5.7,0.1-10.3,0.3-10.3c0.1,0,0.3,4.6,0.3,10.3 S490.9,347.7,490.7,347.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M498,347.7c-0.1,0-0.3-4.6-0.3-10.4c0-5.7,0.1-10.4,0.3-10.4c0.1,0,0.3,4.6,0.3,10.4 C498.3,343,498.2,347.7,498,347.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 456,
    y: 308.2,
    className: "st0",
    width: 20.7,
    height: 7.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M476.8,315.5c0,0.1-4.6,0.3-10.3,0.3c-5.7,0-10.3-0.1-10.3-0.3c0-0.1,4.6-0.3,10.3-0.3 C472.2,315.2,476.8,315.4,476.8,315.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M476.8,308.2c0,0.1-4.6,0.3-10.4,0.3c-5.7,0-10.4-0.1-10.4-0.3c0-0.1,4.6-0.3,10.4-0.3 C472.1,308,476.8,308.1,476.8,308.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 321.3,
    y: 47.7,
    className: "st0",
    width: 7.3,
    height: 20.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M321.3,68.5c-0.1,0-0.3-4.6-0.3-10.3s0.1-10.3,0.3-10.3c0.1,0,0.3,4.6,0.3,10.3 C321.6,63.9,321.5,68.5,321.3,68.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M328.6,68.5c-0.1,0-0.3-4.6-0.3-10.4c0-5.7,0.1-10.4,0.3-10.4c0.1,0,0.3,4.6,0.3,10.4 C328.8,63.9,328.7,68.5,328.6,68.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 167.8,
    y: 158.3,
    className: "st0",
    width: 7.3,
    height: 20.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M167.8,179.1c-0.1,0-0.3-4.6-0.3-10.3s0.1-10.3,0.3-10.3s0.3,4.6,0.3,10.3S168,179.1,167.8,179.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M175.1,179.1c-0.1,0-0.3-4.6-0.3-10.4c0-5.7,0.1-10.4,0.3-10.4s0.3,4.6,0.3,10.4 C175.4,174.5,175.2,179.1,175.1,179.1z"
  }))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Bricks"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M692.8,368c0,0,0.6,0,1.5-0.4c0.5-0.2,1-0.6,1.4-1.2c0.5-0.6,0.8-1.4,0.7-2.4c0-2,0-4.4,0-7.1 c0-1.4,0-2.9,0-4.5c0-0.8,0-1.6,0-2.4c-0.1-0.8-0.5-1.6-1.1-2.1c-0.6-0.6-1.4-0.9-2.3-1c-0.9,0-1.8,0-2.8,0c-1.9,0-3.9,0-6,0 c-4.1,0-8.5,0-13.2,0c-9.3,0-19.5,0-30.2,0c-1.3,0-2.5,0.7-3.1,1.8c-0.3,0.5-0.5,1.1-0.5,1.8c0,0.7,0,1.3,0,2 c0,2.6,0,5.2,0,7.7c0,1.3,0,2.5,0,3.7c-0.1,1.2,0.4,2.3,1.3,3c0.4,0.3,1,0.6,1.5,0.7s1.1,0.1,1.7,0.1c1.2,0,2.4,0,3.5,0 c9.3,0,17.6,0,24.6,0.1c7,0,12.7,0.1,16.6,0.1c1.9,0,3.5,0,4.5,0c0.5,0,0.9,0,1.2,0C692.6,368,692.8,368,692.8,368 s-0.1,0-0.4,0c-0.3,0-0.7,0-1.2,0c-1.1,0-2.6,0-4.5,0c-3.9,0-9.6,0-16.6,0.1c-7,0-15.4,0-24.6,0.1c-1.2,0-2.3,0-3.5,0 c-0.6,0-1.2,0-1.8-0.1s-1.2-0.4-1.7-0.8c-1-0.8-1.6-2.1-1.5-3.4c0-1.2,0-2.5,0-3.7c0-2.5,0-5.1,0-7.7c0-0.7,0-1.3,0-2 s0.2-1.4,0.5-2c0.7-1.2,2.1-2.1,3.5-2c10.7,0,20.9,0,30.2,0c4.6,0,9,0,13.2,0c2.1,0,4.1,0,6,0c1,0,1.9,0,2.8,0 c1,0,1.9,0.4,2.5,1.1c0.7,0.6,1.1,1.5,1.2,2.4c0.1,0.9,0,1.7,0,2.5c0,1.6,0,3.1,0,4.5c0,2.8,0,5.2,0,7.1c0,1-0.3,1.9-0.8,2.5 s-1,1-1.5,1.2s-0.9,0.3-1.1,0.3C692.9,368.1,692.8,368,692.8,368z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M399.5,121c0,0,0.6,0,1.5-0.4c0.5-0.2,1-0.6,1.4-1.2c0.5-0.6,0.8-1.4,0.7-2.4c0-2,0-4.4,0-7.1 c0-1.4,0-2.9,0-4.5c0-0.8,0-1.6,0-2.4c-0.1-0.8-0.5-1.6-1.1-2.1c-0.6-0.6-1.4-0.9-2.3-1c-0.9,0-1.8,0-2.8,0c-1.9,0-3.9,0-6,0 c-4.1,0-8.5,0-13.2,0c-9.3,0-19.5,0-30.2,0c-1.3,0-2.5,0.7-3.1,1.8c-0.3,0.5-0.5,1.1-0.5,1.8c0,0.7,0,1.3,0,2 c0,2.6,0,5.2,0,7.7c0,1.3,0,2.5,0,3.7c-0.1,1.2,0.4,2.3,1.3,3c0.4,0.3,1,0.6,1.5,0.7s1.1,0.1,1.7,0.1c1.2,0,2.4,0,3.5,0 c9.3,0,17.6,0,24.6,0.1c7,0,12.7,0.1,16.6,0.1c1.9,0,3.5,0,4.5,0c0.5,0,0.9,0,1.2,0C399.4,121,399.5,121,399.5,121 s-0.1,0-0.4,0s-0.7,0-1.2,0c-1.1,0-2.6,0-4.5,0c-3.9,0-9.6,0-16.6,0.1c-7,0-15.4,0-24.6,0.1c-1.2,0-2.3,0-3.5,0 c-0.6,0-1.2,0-1.8-0.1c-0.6-0.1-1.2-0.4-1.7-0.8c-1-0.8-1.6-2.1-1.5-3.4c0-1.2,0-2.5,0-3.7c0-2.5,0-5.1,0-7.7c0-0.7,0-1.3,0-2 s0.2-1.4,0.5-2c0.7-1.2,2.1-2.1,3.5-2c10.7,0,20.9,0,30.2,0c4.6,0,9,0,13.2,0c2.1,0,4.1,0,6,0c1,0,1.9,0,2.8,0 c1,0,1.9,0.4,2.5,1.1c0.7,0.6,1.1,1.5,1.2,2.4s0,1.7,0,2.5c0,1.6,0,3.1,0,4.5c0,2.8,0,5.2,0,7.1c0,1-0.3,1.9-0.8,2.5 s-1,1-1.5,1.2s-0.9,0.3-1.1,0.3C399.6,121,399.5,121,399.5,121z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M378.1,142.4c0,0,0.6,0,1.5-0.4c0.5-0.2,1-0.6,1.4-1.2c0.5-0.6,0.8-1.4,0.7-2.4c0-2,0-4.4,0-7.1 c0-1.4,0-2.9,0-4.5c0-0.8,0-1.6,0-2.4c-0.1-0.8-0.5-1.6-1.1-2.1c-0.6-0.6-1.4-0.9-2.3-1c-0.9,0-1.8,0-2.8,0c-1.9,0-3.9,0-6,0 c-4.1,0-8.5,0-13.2,0c-9.3,0-19.5,0-30.2,0c-1.3,0-2.5,0.7-3.1,1.8c-0.3,0.5-0.5,1.1-0.5,1.8c0,0.7,0,1.3,0,2 c0,2.6,0,5.2,0,7.7c0,1.3,0,2.5,0,3.7c-0.1,1.2,0.4,2.3,1.3,3c0.4,0.3,1,0.6,1.5,0.7c0.5,0.1,1.1,0.1,1.7,0.1 c1.2,0,2.4,0,3.5,0c9.3,0,17.6,0,24.6,0.1c7,0,12.7,0.1,16.6,0.1c1.9,0,3.5,0,4.5,0c0.5,0,0.9,0,1.2,0 C378,142.4,378.1,142.4,378.1,142.4s-0.1,0-0.4,0s-0.7,0-1.2,0c-1.1,0-2.6,0-4.5,0c-3.9,0-9.6,0-16.6,0.1c-7,0-15.4,0-24.6,0.1 c-1.2,0-2.3,0-3.5,0c-0.6,0-1.2,0-1.8-0.1c-0.6-0.1-1.2-0.4-1.7-0.8c-1-0.8-1.6-2.1-1.5-3.4c0-1.2,0-2.5,0-3.7 c0-2.5,0-5.1,0-7.7c0-0.7,0-1.3,0-2s0.2-1.4,0.5-2c0.7-1.2,2.1-2.1,3.5-2c10.7,0,20.9,0,30.2,0c4.6,0,9,0,13.2,0 c2.1,0,4.1,0,6,0c1,0,1.9,0,2.8,0c1,0,1.9,0.4,2.5,1.1c0.7,0.6,1.1,1.5,1.2,2.4s0,1.7,0,2.5c0,1.6,0,3.1,0,4.5 c0,2.8,0,5.2,0,7.1c0,1-0.3,1.9-0.8,2.5s-1,1-1.5,1.2s-0.9,0.3-1.1,0.3C378.2,142.4,378.1,142.4,378.1,142.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M163.5,123.2c0,0,0.6,0,1.5-0.4c0.5-0.2,1-0.6,1.4-1.2c0.5-0.6,0.8-1.4,0.7-2.4c0-2,0-4.4,0-7.1 c0-1.4,0-2.9,0-4.5c0-0.8,0-1.6,0-2.4c-0.1-0.8-0.5-1.6-1.1-2.1c-0.6-0.6-1.4-0.9-2.3-1c-0.9,0-1.8,0-2.8,0c-1.9,0-3.9,0-6,0 c-4.1,0-8.5,0-13.2,0c-9.3,0-19.5,0-30.2,0c-1.3,0-2.5,0.7-3.1,1.8c-0.3,0.5-0.5,1.1-0.5,1.8c0,0.7,0,1.3,0,2c0,2.6,0,5.2,0,7.7 c0,1.3,0,2.5,0,3.7c-0.1,1.2,0.4,2.3,1.3,3c0.4,0.3,1,0.6,1.5,0.7s1.1,0.1,1.7,0.1c1.2,0,2.4,0,3.5,0c9.3,0,17.6,0,24.6,0.1 c7,0,12.7,0.1,16.6,0.1c1.9,0,3.5,0,4.5,0c0.5,0,0.9,0,1.2,0C163.4,123.2,163.5,123.2,163.5,123.2s-0.1,0-0.4,0 c-0.3,0-0.7,0-1.2,0c-1.1,0-2.6,0-4.5,0c-3.9,0-9.6,0-16.6,0.1c-7,0-15.4,0-24.6,0.1c-1.2,0-2.3,0-3.5,0c-0.6,0-1.2,0-1.8-0.1 c-0.6-0.1-1.2-0.4-1.7-0.8c-1-0.8-1.6-2.1-1.5-3.4c0-1.2,0-2.5,0-3.7c0-2.5,0-5.1,0-7.7c0-0.7,0-1.3,0-2s0.2-1.4,0.5-2 c0.7-1.2,2.1-2.1,3.5-2c10.7,0,20.9,0,30.2,0c4.6,0,9,0,13.2,0c2.1,0,4.1,0,6,0c1,0,1.9,0,2.8,0c1,0,1.9,0.4,2.5,1.1 c0.7,0.6,1.1,1.5,1.2,2.4c0.1,0.9,0,1.7,0,2.5c0,1.6,0,3.1,0,4.5c0,2.8,0,5.2,0,7.1c0,1-0.3,1.9-0.8,2.5s-1,1-1.5,1.2 s-0.9,0.3-1.1,0.3C163.6,123.2,163.5,123.2,163.5,123.2z"
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Hole"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M582.8,360L582.8,360c-7.6,0-13.9,6.3-13.9,13.9v16.7h27.3v-17.2C596.2,366,590.2,360,582.8,360z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M586.1,360.3c-6.4,1.3-11.2,7.8-11.2,15.6v14.3h22.5v-14.3C597.4,368.1,592.5,361.6,586.1,360.3z"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Character_00000017491550106623609660000005515804114352258211_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 345.9,
    cy: 425.2,
    rx: 171.4,
    ry: 20.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M421.1,349.7c0.7,1.1,46.4,59.5,46.4,59.5l60,36l-13.6,14.3c0,0-65.1-16.2-72.2-24.1s-34.8-39.1-34.8-39.1 L421.1,349.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M451.6,424.7c0,0,0-0.3,0.2-0.7c0.1-0.5,0.4-1.1,0.8-1.9c0.8-1.6,2.2-3.6,4.2-5.4s4.3-2.9,5.9-3.4 c0.8-0.3,1.5-0.5,2-0.5c0.5-0.1,0.8-0.1,0.8-0.1c0,0.1-1,0.3-2.7,0.9c-1.6,0.6-3.7,1.8-5.7,3.5s-3.4,3.7-4.2,5.2 C452.1,423.7,451.7,424.8,451.6,424.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M547.5,451.2l17.2,10.6c0.8,0.5,1.5,1.2,2,2l6.4,10.8c1.4,2.7-1.2,5.7-4,4.5c0,0-0.1,0-0.1-0.1 c0,0-4.6,1.5-7.3-0.4s-8.1-10.4-8.1-10.4l-4.8-0.6l5.6,11.1c0,0-4.4,1.5-7.3-1c-2.9-2.5-7.4-9.6-7.4-9.6l-8-2.1 c0,0-4.1,2.4-11.1,0.8c0,0,0.1,9.3-6.2,12.1c-2.9,1.3-2.7-3.3-2.7-3.3l0.8-7.1c-0.1-0.6-0.8-2.5-0.7-3.1l3.3-13.3l9-8.5 L547.5,451.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M549.4,465.6c0,0,0.4,0.2,1.1,0.7c0.8,0.5,1.8,1.1,3.1,2l0,0l0,0c1.4,1.8,3.2,4.3,5.4,7 c0.5,0.7,1.1,1.4,1.7,2.1c0.6,0.7,1.2,1.5,2.1,1.8c0.9,0.4,1.9,0.4,2.9,0.3s2.1-0.3,3.1-0.7l-0.1,0.4c-0.5-1-1.1-2.1-1.7-3.2 c-2.1-3.9-4.1-7.7-5.8-11l0.1,0.1c-4.2-2.6-7.8-4.9-10.4-6.5c-1.2-0.8-2.2-1.4-2.9-1.9c-0.7-0.4-1-0.7-1-0.7s0.4,0.2,1.1,0.6 c0.8,0.4,1.8,1,3,1.8c2.6,1.6,6.2,3.8,10.5,6.3h0.1v0.1c1.8,3.3,3.8,7,5.9,11c0.6,1.1,1.2,2.2,1.7,3.2l0.1,0.3l-0.3,0.1 c-1.1,0.4-2.1,0.6-3.2,0.7c-1.1,0.1-2.2,0-3.1-0.4c-0.3-0.1-0.5-0.2-0.7-0.4c-0.2-0.2-0.4-0.3-0.6-0.5c-0.3-0.4-0.7-0.7-1-1.1 c-0.6-0.7-1.2-1.4-1.7-2.1c-2.2-2.8-3.9-5.3-5.2-7.1l0,0c-1.3-0.9-2.3-1.6-3-2.1C549.8,465.9,549.4,465.6,549.4,465.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M530.1,465.6c0,0,0.2,0,0.7,0.1s1.1,0.3,1.9,0.5c1.7,0.4,4.1,1.1,7,1.8h0.1v0.1c1.2,2,2.7,4.4,4.6,6.7 c1,1.1,2,2.3,3.3,3.2c1.3,0.8,3,1.3,4.6,1.1c0.6-0.1,1.3-0.3,1.8-0.6l-0.1,0.3c-2.9-5.6-5.5-10.6-7.5-14.5l0.1,0.1 c-2.3-1.8-4.1-3.2-5.5-4.3c-0.6-0.5-1.1-0.9-1.5-1.2c-0.3-0.3-0.5-0.4-0.5-0.4s0.2,0.1,0.6,0.4c0.4,0.3,0.9,0.7,1.5,1.1 c1.4,1,3.3,2.4,5.6,4.1l0,0l0,0c2.1,3.9,4.7,8.9,7.6,14.5l0.1,0.2l-0.2,0.1c-0.7,0.4-1.3,0.5-2.1,0.6c-1.8,0.2-3.5-0.3-5-1.2 c-1.4-0.9-2.5-2.2-3.4-3.3c-1.9-2.4-3.4-4.7-4.6-6.8l0.1,0.1c-2.9-0.8-5.3-1.5-7-2c-0.8-0.2-1.4-0.4-1.9-0.6 C530.3,465.7,530.1,465.6,530.1,465.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M512.7,479c0-0.1,0.3,0.1,0.8,0.1s1.3-0.2,2-0.7c0.7-0.6,1.5-1.4,2.2-2.5c0.3-0.5,0.7-1.1,1-1.7 s0.6-1.2,0.8-1.9c0.6-2.2,0.9-4.3,1-6v-0.1l0.1-0.1c1.1-0.8,2.1-1.4,2.8-1.8s1.1-0.6,1.1-0.6s-0.3,0.3-0.9,0.8 c-0.6,0.5-1.5,1.2-2.6,2l0.1-0.2c-0.1,1.7-0.3,3.9-0.9,6.1c-0.2,0.7-0.5,1.4-0.8,2c-0.4,0.6-0.7,1.2-1.1,1.7 c-0.7,1.1-1.5,2-2.3,2.5c-0.8,0.6-1.7,0.7-2.2,0.6c-0.3,0-0.5-0.1-0.6-0.2C512.8,479,512.7,479,512.7,479z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M516.7,451.9c0.1,0.1-1.3,1.7-2.3,4c-1,2.4-1.2,4.5-1.3,4.5s-0.2-2.2,0.8-4.7 C515,453.3,516.6,451.8,516.7,451.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M264.7,349.7c-0.7,1.1-46.4,59.5-46.4,59.5l-60,36l13.6,14.3c0,0,65.1-16.2,72.2-24.1 c7.1-7.9,34.8-39.1,34.8-39.1L264.7,349.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M234.1,424.7c-0.1,0-0.4-1-1.3-2.5c-0.8-1.5-2.2-3.5-4.2-5.2s-4.1-2.9-5.7-3.5c-1.6-0.6-2.7-0.8-2.7-0.9 c0,0,0.3,0,0.8,0.1s1.2,0.2,2,0.5c1.7,0.5,3.9,1.7,5.9,3.4c2,1.8,3.4,3.9,4.2,5.4c0.4,0.8,0.6,1.5,0.8,1.9 C234.1,424.5,234.2,424.7,234.1,424.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M138.7,450.4L121.5,461c-0.8,0.5-1.5,1.2-2,2l-6.4,10.8c-1.4,2.7,1.2,5.7,4,4.5c0,0,0.1,0,0.1-0.1 c0,0,4.6,1.5,7.3-0.4c2.7-1.9,8.1-10.4,8.1-10.4l4.8-0.6l-5.6,11.1c0,0,4.4,1.5,7.3-1c2.9-2.5,7.4-9.6,7.4-9.6l8-2.1 c0,0,4.1,2.4,11.1,0.8c0,0-0.1,9.3,6.2,12.1c2.9,1.3,2.7-3.3,2.7-3.3l-0.8-7.1c0.1-0.6,0.8-2.5,0.7-3.1l-3.3-13.3l-9-8.5 L138.7,450.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M136.7,464.7c0,0-0.4,0.3-1,0.8c-0.8,0.5-1.8,1.2-3,2.1l0,0c-1.3,1.9-3.1,4.3-5.2,7.1 c-0.5,0.7-1.1,1.4-1.7,2.1c-0.3,0.4-0.6,0.7-1,1.1c-0.2,0.2-0.4,0.3-0.6,0.5c-0.2,0.1-0.4,0.3-0.7,0.4c-1,0.4-2.1,0.5-3.1,0.4 c-1.1-0.1-2.1-0.3-3.2-0.7l-0.3-0.1l0.1-0.3c0.5-1,1.1-2.1,1.7-3.2c2.1-3.9,4.1-7.7,5.9-11v-0.1h0.1c4.3-2.6,7.9-4.7,10.5-6.3 c1.2-0.7,2.2-1.3,3-1.8c0.7-0.4,1.1-0.6,1.1-0.6s-0.3,0.3-1,0.7c-0.7,0.5-1.7,1.1-2.9,1.9c-2.6,1.6-6.2,3.9-10.4,6.5l0.1-0.1 c-1.8,3.3-3.7,7.1-5.8,11c-0.6,1.1-1.2,2.2-1.7,3.2l-0.1-0.4c1,0.3,2,0.6,3.1,0.7c1,0.1,2,0,2.9-0.3s1.5-1.1,2.1-1.8 c0.6-0.7,1.2-1.4,1.7-2.1c2.2-2.8,4-5.2,5.4-7l0,0l0,0c1.3-0.8,2.3-1.5,3.1-2C136.3,464.9,136.7,464.7,136.7,464.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M156,464.8c0,0-0.2,0.1-0.7,0.2s-1.1,0.3-1.9,0.6c-1.7,0.5-4.1,1.2-7,2l0.1-0.1c-1.2,2.1-2.7,4.4-4.6,6.8 c-1,1.2-2,2.4-3.4,3.3s-3.2,1.4-5,1.2c-0.7-0.1-1.4-0.3-2.1-0.6l-0.2-0.1l0.1-0.2c2.9-5.5,5.5-10.5,7.6-14.5l0,0l0,0 c2.3-1.7,4.2-3.1,5.6-4.1c0.6-0.5,1.1-0.8,1.5-1.1c0.4-0.2,0.5-0.4,0.6-0.4c0,0-0.2,0.2-0.5,0.4c-0.4,0.3-0.9,0.7-1.5,1.2 c-1.4,1.1-3.2,2.5-5.5,4.3l0.1-0.1c-2,3.9-4.6,9-7.5,14.5l-0.1-0.3c0.5,0.3,1.2,0.5,1.8,0.6c1.6,0.2,3.3-0.3,4.6-1.1 c1.3-0.9,2.4-2.1,3.3-3.2c1.9-2.3,3.4-4.6,4.6-6.7v-0.1h0.1c2.9-0.8,5.3-1.4,7-1.8c0.8-0.2,1.4-0.3,1.9-0.5 C155.8,464.8,156,464.7,156,464.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M173.4,478.1c0,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.3,0.1-0.6,0.2c-0.6,0.1-1.4-0.1-2.2-0.6 c-0.8-0.6-1.6-1.5-2.3-2.5c-0.4-0.5-0.7-1.1-1.1-1.7c-0.4-0.6-0.6-1.3-0.8-2c-0.7-2.2-0.9-4.4-0.9-6.1l0.1,0.2 c-1.1-0.8-2-1.5-2.6-2s-1-0.8-0.9-0.8c0,0,0.4,0.2,1.1,0.6c0.7,0.4,1.6,1.1,2.8,1.8l0.1,0.1v0.1c0.1,1.7,0.4,3.8,1,6 c0.2,0.7,0.5,1.4,0.8,1.9c0.3,0.6,0.7,1.2,1,1.7c0.7,1,1.4,1.9,2.2,2.5c0.7,0.6,1.5,0.8,2,0.7 C173.1,478.2,173.4,478.1,173.4,478.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M169.4,451.1c0.1-0.1,1.8,1.4,2.8,3.8c1.1,2.5,1,4.7,0.8,4.7s-0.3-2.1-1.3-4.5 C170.7,452.8,169.3,451.2,169.4,451.1z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M381.2,204c2.6-2.9,3-7.5,1.1-10.9c-2-3.4-6.2-5.3-10-4.5c-0.4-3.8-2.8-7.4-6.3-9.1 c-3.5-1.7-7.8-1.4-11,0.8c-4.4-3.4-11.3-3.2-15.5,0.5c-3.8-0.5-7.8,1.7-9.3,5.2c-1.6,3.5-0.6,7.9,2.2,10.4l46.1,25.3 c4.4,0.3,8.7-3.2,9.5-7.5C388.4,209.8,385.4,205.2,381.2,204z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M337.8,189.8l2-0.1c19.9-1,37.2,13.5,39.8,33.2c2.4,18.4,4.8,38.7,5.2,48.6 c0.8,20.5-19.6,24.7-19.6,24.7l3,24.5l-49.8,0.9l-8.8-89.1C306.6,211.4,316.6,192.1,337.8,189.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M365.4,296.2c0,0-13.1,1.4-27.3-6.5c0,0,7.1,14.4,27.4,11.6L365.4,296.2z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M374.4,242.6c0.1,1.5-1.1,2.9-2.7,3.1c-1.6,0.2-3-0.9-3.1-2.5c-0.1-1.5,1.1-2.9,2.7-3.1 C372.9,240,374.3,241.1,374.4,242.6z"
  }))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M375.7,233.2c-0.3,0.4-2.6-1.1-5.8-1c-3.1,0.1-5.4,1.9-5.7,1.5c-0.2-0.2,0.2-0.9,1.1-1.7 c1-0.8,2.6-1.6,4.6-1.7c2-0.1,3.6,0.6,4.6,1.2C375.5,232.3,375.9,233,375.7,233.2z"
  })))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M347.7,244.8c0.1,1.5-1.1,2.9-2.7,3.1c-1.6,0.2-3-0.9-3.1-2.5c-0.1-1.5,1.1-2.9,2.7-3.1 C346.2,242.1,347.6,243.2,347.7,244.8z"
  }))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M344.8,235.3c-0.3,0.4-2.6-1.1-5.8-1c-3.1,0.1-5.4,1.9-5.7,1.5c-0.2-0.2,0.2-0.9,1.1-1.7 c1-0.8,2.6-1.6,4.6-1.7c2-0.1,3.6,0.6,4.6,1.2C344.6,234.5,344.9,235.1,344.8,235.3z"
  })))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M357.4,258.1c0-0.2,1.9-0.6,5.1-1.2c0.8-0.1,1.6-0.3,1.7-0.9c0.2-0.6-0.2-1.4-0.7-2.4 c-0.9-1.9-1.7-3.9-2.7-6c-3.7-8.6-6.5-15.6-6.1-15.8c0.3-0.1,3.7,6.7,7.4,15.2c0.9,2.1,1.8,4.1,2.6,6 c0.3,0.9,0.9,1.9,0.6,3.1c-0.2,0.6-0.8,1.1-1.3,1.2c-0.5,0.2-1,0.2-1.4,0.3 C359.4,258.2,357.4,258.3,357.4,258.1z"
  }))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M346.9,223c-0.4,0.8-3.1,0.1-6.4,0.1s-6.1,0.7-6.4-0.1c-0.2-0.4,0.4-1.1,1.6-1.8 s2.9-1.3,4.9-1.3s3.8,0.6,4.9,1.2C346.5,221.9,347.1,222.7,346.9,223z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M375.2,220.2c-0.6,0.7-3.3,0.1-6.4,0.3c-3.1,0-5.8,0.8-6.4,0c-0.3-0.4,0.1-1.1,1.2-1.8 s3-1.4,5.1-1.4c2.2,0,4,0.5,5.2,1.2C375.1,219.1,375.5,219.8,375.2,220.2z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M377.2,213.6c0,0-6-12.6-12.4-15.3c-7.7-3.3-10.5,5.1-17.7,3.5s-14.6-4.8-21.6,1.1 c-7.7,6.4-3.7,10.5-3.8,19.6c-0.2,37-6.4,47.7-9.2,30.5c-0.3-1.9-5.7-3.1-6.8-11.1c-1.5-10.4-2.6-23-0.6-30.5 c1.7-6.3,5-10.8,11.1-15.9c9.7-8,23.5-8.8,33-8.4C358.6,187.6,377.2,197.5,377.2,213.6z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M313.8,252.4c-0.3-3.2-3.1-5.5-6.3-5.1c-3.8,0.6-8,2.9-7.3,10.8c1.1,14,15,10,14.9,9.6 C315.2,267.5,314.3,258.3,313.8,252.4z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M311.7,262.7c-0.1,0-0.2,0.2-0.6,0.4c-0.4,0.2-1.1,0.4-1.8,0.2c-1.5-0.4-3-2.7-3.2-5.2 c-0.1-1.3,0-2.5,0.4-3.5c0.3-1.1,0.9-1.8,1.7-2c0.7-0.2,1.3,0.2,1.5,0.6c0.2,0.4,0.2,0.7,0.2,0.7s0.3-0.3,0.1-0.8 c-0.1-0.3-0.3-0.6-0.6-0.8c-0.4-0.2-0.9-0.3-1.4-0.2c-1.1,0.2-2,1.2-2.4,2.4c-0.5,1.2-0.7,2.5-0.5,4 c0.3,2.8,2,5.3,4.1,5.8c1,0.2,1.8-0.2,2.2-0.6C311.7,263.1,311.7,262.8,311.7,262.7z"
  }))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M303.1,221.8c11.6-5.6,21.7-8.6,34.5-11.8s29.4-5.8,37.2-4.8c1.9,3.5,3.1,7,3.5,10.4c0,0-53.7,4-74.5,17.4 L303.1,221.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M313.4,224.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M310.3,220.6c0,0,0,3.5,4.8,5.3c2.1,0.8,4.9,0.5,6.4-2.1c0.5-0.9,2.5-3.5,2.5-3.5s3.1,0.6,4.3,0.7 c4.1,0.2,8.6-5.4,8.6-8.9c1.1,1.5,3.2,1.3,4.9,0.8c1.3-0.4,2.3-1.3,3.4-2.8c2.7-3.7,1.8-6.7,1.8-6.7c1,0.1,5-1.2,5.8-1.8 c1.4-1.2,3.9-4.3,4.1-6.2c0.2-1.8-0.9,4,0.7,2.9c1.4-1,3.3-0.6,5-0.4c1.7,0.2,3.9-0.3,4.2-2c0.2-0.9-0.2-1.8-0.8-2.5 c-2.4-3.3-7.2-4.6-10.9-2.9c-1.6-4.6-6.1-8-10.9-8.2c-4.8-0.3-9.7,2.6-11.8,7c-3.1-2.5-7.5-3.5-11.3-2.4 c-3.9,1.1-7.1,4.1-8.4,7.9c-3.5-0.7-7.3,0.8-9.3,3.7s-2.1,7-0.3,10c-2.4,1.6-5.3,4.3-4.4,7.1 C301.3,223.8,307.5,221.5,310.3,220.6"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M356.3,194.5c0,0,0,0.1,0,0.3s0,0.4-0.1,0.8c-0.1,0.7-0.3,1.6-0.9,2.8c-0.6,1.1-1.5,2.4-2.9,3.5 s-3.4,1.9-5.7,1.9l0.2-0.3c0.5,1.2,0.4,2.6-0.1,3.9c-0.5,1.3-1.3,2.4-2.2,3.6c-0.5,0.5-0.8,1.2-1.5,1.7 c-0.6,0.5-1.4,0.8-2.2,0.9c-1.6,0.3-3.4-0.1-4.6-1.4l0.5-0.2c-0.2,2.8-1.7,5.7-4.1,7.5c-1.3,1-2.9,1.7-4.5,1.7 c-1.6,0.1-3.2-0.3-4.6-0.8l0.4-0.2c-0.7,1.8-1.8,3.3-3.1,4.5c-1.3,1.2-3.1,1.9-4.8,1.6c-3.3-0.5-5.7-3.2-6.2-5.7l0.3,0.1 c-1.6,1-3.4,1.1-4.8,0.9c-1.4-0.2-2.6-0.8-3.4-1.3c-0.8-0.6-1.3-1.2-1.7-1.6c-0.3-0.4-0.4-0.7-0.4-0.7 c0.1-0.1,0.5,1,2.2,2.1c0.8,0.5,2,1,3.3,1.2c1.4,0.2,3,0,4.5-1l0.3-0.2l0.1,0.3c0.6,2.4,2.8,4.9,5.9,5.3 c1.5,0.3,3.1-0.4,4.4-1.5s2.3-2.6,2.9-4.3l0.1-0.3l0.3,0.1c1.4,0.4,2.9,0.8,4.4,0.7c1.5,0,3-0.6,4.2-1.6 c2.3-1.7,3.7-4.4,3.9-7.1l0.1-0.7l0.5,0.5c1,1.1,2.6,1.5,4.1,1.2c0.7-0.1,1.4-0.4,1.9-0.8c0.5-0.4,0.9-1,1.4-1.6 c0.9-1.1,1.7-2.2,2.2-3.4s0.6-2.5,0.1-3.5l-0.1-0.3h0.4c2.1,0,4-0.7,5.4-1.8c1.4-1,2.3-2.2,2.9-3.3 C356.4,196,356.2,194.5,356.3,194.5z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M371.3,215.1l-16,2.1c-1.2,0.2-2.4-0.7-2.5-1.9l-1.3-9.8c-0.2-1.2,0.7-2.4,1.9-2.5l16-2.1 c1.2-0.2,2.4,0.7,2.5,1.9l1.3,9.8C373.4,213.8,372.5,214.9,371.3,215.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M371.3,215.1c0,0,0.2,0,0.6-0.2s0.9-0.6,1.1-1.4c0.1-0.4,0.1-0.8,0-1.3s-0.2-1.1-0.2-1.6 c-0.2-1.2-0.4-2.5-0.6-4c-0.1-0.7-0.2-1.5-0.3-2.3c-0.1-0.4-0.1-0.8-0.2-1.2c0-0.4-0.2-0.8-0.4-1.1c-0.5-0.6-1.3-0.9-2.2-0.7 c-0.9,0.1-1.9,0.3-2.9,0.4c-3.9,0.5-8.2,1.1-12.7,1.7c-1,0.1-1.8,1.1-1.7,2.1c0.1,1.1,0.3,2.2,0.4,3.2 c0.3,2.1,0.5,4.2,0.8,6.2c0.1,0.5,0.1,0.9,0.3,1.3c0.2,0.4,0.6,0.7,1,0.8c0.4,0.2,0.8,0.2,1.2,0.1c0.5-0.1,0.9-0.1,1.3-0.2 c1.7-0.2,3.4-0.4,4.9-0.6c2.9-0.4,5.3-0.6,7-0.8c0.8-0.1,1.4-0.2,1.9-0.2C371,215.1,371.3,215,371.3,215.1 c0,0-0.2,0.1-0.7,0.1c-0.5,0.1-1.1,0.2-1.9,0.3c-1.7,0.2-4.1,0.6-7,1c-1.5,0.2-3.1,0.4-4.8,0.7c-0.4,0.1-0.9,0.1-1.3,0.2 c-0.4,0.1-1,0.1-1.5-0.1c-0.5-0.2-0.9-0.5-1.2-1c-0.3-0.5-0.4-1-0.4-1.5c-0.3-2-0.5-4-0.8-6.1c-0.1-1.1-0.3-2.2-0.4-3.3 c-0.1-1.3,0.9-2.5,2.2-2.7c4.5-0.6,8.8-1.2,12.8-1.7c1-0.1,1.9-0.2,2.9-0.4c0.4-0.1,1-0.1,1.5,0.1c0.5,0.2,0.9,0.5,1.2,0.8 c0.3,0.4,0.5,0.9,0.5,1.3c0.1,0.4,0.1,0.8,0.2,1.2c0.1,0.8,0.2,1.6,0.3,2.3c0.2,1.5,0.3,2.8,0.5,4c0.1,0.6,0.1,1.1,0.2,1.6 s0.1,1,0,1.4c-0.3,0.9-0.9,1.3-1.3,1.4C371.5,215.1,371.3,215.1,371.3,215.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.4,216.7l-3.6,0.5c-1.4,0.2-2.7-0.8-2.9-2.2l-1.2-9.2c-0.2-1.4,0.8-2.7,2.2-2.9l3.6-0.5L359.4,216.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M370.7,208.7c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4 C368.3,203.3,370.7,205.7,370.7,208.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M370.7,208.7c-0.1,0,0-0.5-0.3-1.3c-0.2-0.8-0.8-2-2-2.8c-1.2-0.9-3.1-1.4-4.9-0.7 c-1.8,0.6-3.4,2.6-3.4,4.8c0,2.3,1.5,4.2,3.4,4.8c1.8,0.7,3.7,0.2,4.9-0.7c1.2-0.9,1.7-2,2-2.8 C370.6,209.2,370.6,208.7,370.7,208.7c0,0,0,0.1,0,0.3s0,0.6-0.1,1c-0.2,0.8-0.7,2.1-1.9,3.1c-1.2,1-3.3,1.6-5.3,0.9 c-1-0.3-1.9-1-2.6-1.9s-1.1-2.1-1.1-3.3s0.4-2.4,1.1-3.3c0.7-0.9,1.6-1.6,2.6-1.9c2-0.7,4.1-0.1,5.3,0.9 c1.3,1,1.8,2.2,1.9,3.1C370.7,208,370.7,208.4,370.7,208.7L370.7,208.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M356.8,265.5L356.8,265.5c-1.3-0.6-2.6-1.2-4-1.4c-1.4-0.2-3,0.2-3.9,1.2s-1.1,2.4-0.9,3.7 c0.3,2,1.5,3.9,3.4,4.7c1.9,0.8,4.3,0.3,5.5-1.3c0.8-1,0.9-2.3,1-3.6C357.9,267.1,357.3,265.6,356.8,265.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M357.4,271.9c0,0.1-0.2,0.3-0.6,0.8c-0.5,0.5-1.2,1.1-2.3,1.6c-0.6,0.3-1.3,0.4-2.1,0.2 c-0.7-0.1-1.5-0.5-2.1-0.9c-0.7-0.4-1.4-1.1-1.8-1.9c-0.4-0.9-0.6-1.7-0.7-2.6c-0.3-1.8,0.3-3.9,1.8-4.9 c0.8-0.5,1.6-0.6,2.4-0.5c0.7,0.1,1.4,0.2,1.9,0.4c1.1,0.4,2,0.6,2.6,1s0.8,0.7,0.7,0.7c0,0.1-0.4-0.1-0.9-0.4 c-0.6-0.3-1.5-0.4-2.6-0.7c-1-0.3-2.5-0.5-3.5,0.2c-1.1,0.8-1.6,2.4-1.3,4c0.1,0.8,0.3,1.7,0.6,2.3c0.3,0.7,0.8,1.2,1.4,1.6 c1.2,0.9,2.4,1.2,3.4,0.8c1-0.4,1.8-0.9,2.3-1.2C357,272,357.3,271.9,357.4,271.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.998 -6.339990e-02 6.339990e-02 0.998 -11.4614 38.4106)",
    className: "st12",
    cx: 599.5,
    cy: 199.8,
    rx: 94.4,
    ry: 98.1
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M505.3,205.8c-2.6-40.9,19.3-77.5,52.7-94.3l-194.5,92.4c-4.8,1.7-5.2,7.8,1.3,10.4l198.3,75.8 C531.1,276,507.7,244.2,505.3,205.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M514,135.6c0.1,0.1-27,13.2-60.5,29.2s-60.7,28.8-60.7,28.7c-0.1-0.1,27-13.2,60.5-29.2 C486.7,148.3,513.9,135.5,514,135.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M687.1,176.2c0,0,0,0.1,0.1,0.4c0.1,0.3,0.1,0.7,0.3,1.2c0.1,0.5,0.2,1.2,0.4,2s0.3,1.7,0.5,2.7 c0.7,4.1,1.3,10,1.2,17.4c0,3.7-0.4,7.7-0.9,12.1c-0.2,1.1-0.3,2.2-0.5,3.3c-0.1,0.6-0.2,1.1-0.3,1.7 c-0.1,0.6-0.2,1.1-0.3,1.7c-0.2,1.1-0.5,2.3-0.7,3.4c-0.3,1.2-0.6,2.3-0.9,3.5c-2.5,9.4-6.8,19.5-12.9,28.9 c-3.1,4.7-6.5,9-10.1,13c-3.6,3.9-7.4,7.3-11.2,10.4c-7.7,6-15.5,10.4-22.3,13.1c-6.9,2.7-12.8,3.9-16.9,4.3 c-0.5,0.1-1,0.1-1.5,0.2s-0.9,0-1.3,0.1c-0.8,0-1.5,0.1-2,0.1s-0.9,0-1.2,0s-0.4,0-0.4,0s0.1,0,0.4,0c0.3,0,0.7-0.1,1.2-0.1 c0.6,0,1.2-0.1,2-0.1c0.4,0,0.8,0,1.3-0.1s0.9-0.1,1.4-0.2c4.1-0.5,10-1.7,16.8-4.5c6.8-2.7,14.5-7.1,22.2-13.1 c3.8-3.1,7.6-6.5,11.2-10.4c3.6-3.9,7-8.2,10.1-12.9c6.1-9.4,10.3-19.4,12.9-28.8c0.3-1.2,0.6-2.3,0.9-3.5 c0.2-1.2,0.5-2.3,0.7-3.4c0.1-0.6,0.2-1.1,0.4-1.7c0.1-0.6,0.2-1.1,0.3-1.7c0.2-1.1,0.4-2.2,0.5-3.3c0.5-4.3,0.9-8.3,0.9-12 c0.2-7.4-0.4-13.3-1-17.4c-0.1-1-0.3-1.9-0.4-2.7c-0.1-0.8-0.3-1.4-0.4-2c-0.1-0.5-0.2-0.9-0.2-1.2 C687.1,176.3,687.1,176.2,687.1,176.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M683.9,168c-0.2,0-0.6-3.1-2.2-6.6c-1.5-3.5-3.5-6-3.4-6c0,0,0.6,0.5,1.4,1.5c0.8,1,1.7,2.5,2.5,4.3 s1.3,3.5,1.5,4.7C683.9,167.2,684,167.9,683.9,168z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M580.5,290.2c-0.1,0.1-22.1-8.1-49.3-18.3C504,261.6,482,253.2,482,253.1c0.1-0.1,22.1,8.1,49.4,18.3 C558.5,281.6,580.5,290.1,580.5,290.2z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M400,317.4c-19.2,7.5-9.6,5.9-9.6,38.3c0,33.5,7.7,50.2,7.7,50.2l52.3-26.7l-15-30.8 C426.5,329.4,422.3,324.5,400,317.4z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "301.1,318.3 323.7,309.4 365.4,307 385,314.5 358.1,329.4 335,328.5  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M407.8,390.4l-7.8-73c0,0-20.4-7-30.8-10.4c0,0-11,11.4-31.8,11.1c-20.4-0.3-24.6-4.9-24.6-4.9 l-28.5,10.9c0,0-18.3,8.3-23.7,16.2c-7.4,10.9-27,38.2-27,38.2l36.6,33l9.1-10.6l1.8,43.2c38,1.7,87.4,2.8,127.9-0.2l-0.8-29.5 L407.8,390.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "358.3,368.7 359.9,399.7 380.4,408.8 395.5,395.9 395.5,367.2 358.3,368.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M265.3,357.6c-0.7,13.5,4.4,26.5,13.4,36.6C276,381.5,269,369.8,265.3,357.6z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M410.7,344.8c0,0,0,0.2,0,0.5c0,0.4,0,0.9,0,1.4c-0.1,1.3-0.1,3.1-0.2,5.2c-0.2,4.4-0.6,10.5-1.1,17.3 c-0.9,13.5-1.9,24.5-2.5,24.4c0,0,0.2-0.7,0.3-1.9c0.1-1.2,0.3-3,0.4-5.2c0.3-4.5,0.8-10.6,1.2-17.3 c0.5-6.7,0.9-12.8,1.2-17.3c0.2-2.1,0.3-3.9,0.4-5.2c0.1-0.6,0.1-1,0.1-1.4C410.7,345,410.7,344.8,410.7,344.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M263.7,354.8c0,0,0.1,0.2,0.3,0.7c0.2,0.5,0.5,1.2,0.9,2.1c0.7,1.8,1.8,4.4,3.1,7.6 c2.6,6.5,6.1,15.4,10,25.2c0.4,0.9,0.7,1.9,1.1,2.7l0,0l0,0c0.4,9.9,0.8,18.7,1.1,25.1c0.1,3.1,0.2,5.7,0.3,7.5 c0,0.8,0,1.5,0,2s0,0.7,0,0.7s0-0.2-0.1-0.7c0-0.5-0.1-1.2-0.1-2c-0.1-1.8-0.2-4.4-0.4-7.5c-0.3-6.4-0.7-15.2-1.2-25.1v0.1 c-0.3-0.9-0.7-1.8-1.1-2.7c-3.8-9.8-7.3-18.7-9.8-25.2c-1.2-3.2-2.2-5.8-2.9-7.7c-0.3-0.9-0.6-1.6-0.8-2.1 C263.8,355.1,263.7,354.8,263.7,354.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M418,444.1l-19.1,0.5v-59.5c0-5.3,4.3-9.6,9.6-9.6l0,0c5.3,0,9.6,4.3,9.6,9.6v59H418z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M315.7,445.5l-20.3-0.5l1.1-58.4c0-5.3,4.3-9.6,9.6-9.6l0,0c5.3,0,9.6,4.3,9.6,9.6L315.7,445.5 L315.7,445.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 311.6,
    y: 421.6,
    className: "st6",
    width: 93.8,
    height: 13.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M315.8,445c-0.1,0-0.3-12.9-0.3-28.8s0.1-28.8,0.3-28.8c0.1,0,0.3,12.9,0.3,28.8 C316,432.2,315.9,445,315.8,445z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M398.9,443.6c-0.1,0-0.3-11.2-0.3-25s0.1-25,0.3-25s0.3,11.2,0.3,25C399.1,432.5,399,443.6,398.9,443.6z"
  })))))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Text",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M538.1,174.8c1.7,0.9,2.9,2.1,3.9,3.7c0.9,1.6,1.4,3.4,1.4,5.5s-0.5,3.9-1.4,5.5s-2.2,2.8-3.9,3.7 s-3.6,1.3-5.8,1.3h-7.9v-21.1h7.9C534.5,173.5,536.4,173.9,538.1,174.8z M536.5,188.5c1.1-1.1,1.6-2.6,1.6-4.5s-0.5-3.5-1.6-4.5 s-2.6-1.6-4.5-1.6h-2.4v12.2h2.4C533.9,190.1,535.4,189.6,536.5,188.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M559.3,190.8h-7.9l-1.3,3.7h-5.4l7.6-21.1h5.9l7.6,21.1h-5.4L559.3,190.8z M558,186.9l-2.6-7.7l-2.6,7.7H558 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M583.5,173.5v4.1h-5.6v17h-5.1v-17h-5.6v-4.1H583.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M599.1,190.8h-7.9l-1.3,3.7h-5.4l7.6-21.1h5.9l7.6,21.1h-5.4L599.1,190.8z M597.8,186.9l-2.6-7.7l-2.6,7.7 H597.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M633.3,194.5h-5.1l-8.6-13v13h-5.1v-21.1h5.1l8.6,13.1v-13.1h5.1V194.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M641.6,193.4c-1.7-0.9-3-2.2-3.9-3.9c-1-1.6-1.5-3.5-1.5-5.6s0.5-3.9,1.5-5.6c1-1.6,2.3-2.9,3.9-3.8 s3.5-1.4,5.4-1.4c2,0,3.8,0.5,5.4,1.4c1.7,0.9,3,2.2,3.9,3.8s1.4,3.5,1.4,5.6s-0.5,3.9-1.4,5.6s-2.3,2.9-3.9,3.9 c-1.6,0.9-3.5,1.4-5.4,1.4C645,194.8,643.2,194.3,641.6,193.4z M651.1,188.4c1-1.1,1.5-2.6,1.5-4.4c0-1.9-0.5-3.3-1.5-4.5 c-1-1.1-2.4-1.7-4-1.7c-1.7,0-3.1,0.6-4.1,1.6c-1,1.1-1.5,2.6-1.5,4.5s0.5,3.3,1.5,4.5c1,1.1,2.4,1.7,4.1,1.7 C648.7,190.1,650,189.5,651.1,188.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M675.8,173.5v4.1h-5.6v17h-5.1v-17h-5.6v-4.1H675.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M562.3,209.5v4.1h-8.6v4.4h6.4v4h-6.4v8.5h-5.1v-21.1h13.7V209.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M569.5,229.4c-1.7-0.9-3-2.2-3.9-3.9c-1-1.6-1.5-3.5-1.5-5.6s0.5-3.9,1.5-5.6c1-1.6,2.3-2.9,3.9-3.8 s3.5-1.4,5.4-1.4c2,0,3.8,0.5,5.4,1.4c1.7,0.9,3,2.2,3.9,3.8s1.4,3.5,1.4,5.6s-0.5,3.9-1.4,5.6s-2.3,2.9-3.9,3.9 c-1.6,0.9-3.5,1.4-5.4,1.4C573,230.8,571.2,230.3,569.5,229.4z M579,224.4c1-1.1,1.5-2.6,1.5-4.4c0-1.9-0.5-3.3-1.5-4.5 c-1-1.1-2.4-1.7-4-1.7c-1.7,0-3.1,0.6-4.1,1.6c-1,1.1-1.5,2.6-1.5,4.5s0.5,3.3,1.5,4.5c1,1.1,2.4,1.7,4.1,1.7 C576.7,226.1,578,225.5,579,224.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M593.7,209.5v12.6c0,1.3,0.3,2.2,0.9,2.9c0.6,0.7,1.5,1,2.7,1s2.1-0.3,2.8-1c0.6-0.7,1-1.7,1-2.9v-12.6h5.1 v12.6c0,1.9-0.4,3.5-1.2,4.8s-1.9,2.3-3.2,2.9c-1.4,0.7-2.9,1-4.5,1s-3.1-0.3-4.5-1c-1.3-0.6-2.3-1.6-3.1-2.9 c-0.8-1.3-1.1-2.9-1.1-4.8v-12.6H593.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M628.6,230.5h-5.1l-8.6-13v13h-5.1v-21.1h5.1l8.6,13.1v-13.1h5.1V230.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M646,210.8c1.7,0.9,2.9,2.1,3.9,3.7c0.9,1.6,1.4,3.4,1.4,5.5s-0.5,3.9-1.4,5.5s-2.2,2.8-3.9,3.7 s-3.6,1.3-5.8,1.3h-7.9v-21.1h7.9C642.4,209.5,644.4,209.9,646,210.8z M644.4,224.5c1.1-1.1,1.6-2.6,1.6-4.5s-0.5-3.5-1.6-4.5 s-2.6-1.6-4.5-1.6h-2.4v12.2h2.4C641.8,226.1,643.3,225.6,644.4,224.5z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 70.1,
    y: 204.9,
    className: "st17",
    width: 121.7,
    height: 154.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 74.4,
    y: 210.5,
    className: "st18",
    width: 113.1,
    height: 33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.4,
    y: 215.9,
    className: "st19",
    width: 6.4,
    height: 27.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.4,
    y: 215.9,
    className: "st19",
    width: 6.4,
    height: 27.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.1,
    y: 215.5,
    transform: "matrix(0.9855 -0.1698 0.1698 0.9855 -36.8236 28.1799)",
    className: "st19",
    width: 6.4,
    height: 27.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.3,
    y: 219.5,
    className: "st19",
    width: 6.4,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.1,
    y: 219.5,
    className: "st19",
    width: 6.4,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.4,
    y: 219.5,
    className: "st19",
    width: 6.4,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.5,
    y: 219.1,
    transform: "matrix(0.9762 -0.2169 0.2169 0.9762 -47.2713 31.4777)",
    className: "st19",
    width: 6.4,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.1,
    y: 214.5,
    className: "st19",
    width: 3.2,
    height: 29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.3,
    y: 214.5,
    className: "st19",
    width: 3.2,
    height: 29
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 74.4,
    y: 248.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 261.8295 530.3541)",
    className: "st18",
    width: 113.1,
    height: 33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 254,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 368.4985 535.6888)",
    className: "st19",
    width: 6.4,
    height: 27.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 254,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 306.3693 535.6888)",
    className: "st19",
    width: 6.4,
    height: 27.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.3,
    y: 253.7,
    transform: "matrix(-0.9855 -0.1698 0.1698 -0.9855 183.9427 550.7336)",
    className: "st19",
    width: 6.4,
    height: 27.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.1,
    y: 257.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 352.5777 539.3283)",
    className: "st19",
    width: 6.4,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.3,
    y: 257.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 323.0444 539.3283)",
    className: "st19",
    width: 6.4,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 257.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 248.4995 539.3283)",
    className: "st19",
    width: 6.4,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.9,
    y: 257.3,
    transform: "matrix(-0.9762 -0.2169 0.2169 -0.9762 222.3546 562.9109)",
    className: "st19",
    width: 6.4,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.5,
    y: 252.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 338.2549 534.3176)",
    className: "st19",
    width: 3.2,
    height: 29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.3,
    y: 252.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 261.8295 534.3176)",
    className: "st19",
    width: 3.2,
    height: 29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.4,
    y: 254,
    className: "st19",
    width: 6.4,
    height: 27.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.3,
    y: 257.7,
    className: "st19",
    width: 6.4,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.1,
    y: 257.7,
    className: "st19",
    width: 6.4,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.1,
    y: 252.7,
    className: "st19",
    width: 3.2,
    height: 29
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 74.4,
    y: 286.9,
    className: "st18",
    width: 113.1,
    height: 33
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 139.3,
    y: 292.2,
    className: "st19",
    width: 6.4,
    height: 27.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.9,
    y: 291.9,
    transform: "matrix(0.9855 -0.1698 0.1698 0.9855 -49.2978 35.0376)",
    className: "st19",
    width: 6.4,
    height: 27.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.2,
    y: 295.8,
    className: "st19",
    width: 6.4,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.9,
    y: 295.8,
    className: "st19",
    width: 6.4,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.2,
    y: 295.8,
    className: "st19",
    width: 6.4,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.4,
    y: 295.4,
    transform: "matrix(0.9762 -0.2169 0.2169 0.9762 -63.0249 40.6372)",
    className: "st19",
    width: 6.4,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.9,
    y: 290.8,
    className: "st19",
    width: 3.2,
    height: 29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 290.8,
    className: "st19",
    width: 3.2,
    height: 29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 291.9,
    transform: "matrix(0.9855 -0.1698 0.1698 0.9855 -50.3716 22.4845)",
    className: "st19",
    width: 6.4,
    height: 27.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.3,
    y: 295.8,
    className: "st19",
    width: 6.4,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    y: 295.4,
    transform: "matrix(0.9762 -0.2169 0.2169 0.9762 -64.7845 24.6055)",
    className: "st19",
    width: 6.4,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.2,
    y: 290.8,
    className: "st19",
    width: 3.2,
    height: 29
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 123.8,
    y: 283.8,
    className: "st20",
    width: 2,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.8,
    y: 283.8,
    className: "st21",
    width: 2,
    height: 3.3
  })), /*#__PURE__*/React.createElement("rect", {
    x: 123.4,
    y: 311.1,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 249.6658 696.5433)",
    className: "st22",
    width: 2.9,
    height: 74.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M132,371.5c0-2.5-1.3-4.7-3.3-5.9l-0.2-4.1h-7.3l-0.2,4.1c-2,1.3-3.3,3.5-3.3,6c0,2.3,1.1,4.3,2.7,5.6 l-0.2,4.2h9.4l-0.2-4.2C131,375.8,132,373.7,132,371.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "128.7,365.7 128.5,361.4 121.2,361.4 121,365.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "120.3,377.4 120.1,381.7 129.6,381.7 129.3,377.4  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M118.2,379.4L118.2,379.4h13.4l0,0c3,3.9,7.3,6.5,12.1,7.5l4.8,1v2.2h-47.2v-2.2l4.8-1 C110.9,385.9,115.2,383.3,118.2,379.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M118.2,379.4L118.2,379.4h13.4l0,0c3,3.9,7.3,6.5,12.1,7.5l4.8,1h-47.2l4.8-1 C110.9,385.9,115.2,383.3,118.2,379.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 122.6,
    y: 296.9,
    className: "st20",
    width: 4.5,
    height: 16.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.6,
    y: 296.9,
    className: "st21",
    width: 4.5,
    height: 16.3
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M125.9,284.4c0.1-0.2,0.1-0.3,0.1-0.5c0-0.7-0.5-1.2-1.2-1.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.2,0.1,0.4,0.1,0.5 H125.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M181.9,350.8c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C182.5,351.5,182,351.2,181.9,350.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 182.3,
    y1: 350,
    x2: 181.7,
    y2: 348.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M180.9,348.1c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C181.5,348.8,181.1,348.6,180.9,348.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 181.3,
    y1: 347.4,
    x2: 180.7,
    y2: 345.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M179.9,345.5c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C180.5,346.2,180.1,345.9,179.9,345.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 180.4,
    y1: 344.7,
    x2: 179.7,
    y2: 342.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M179,342.8c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C179.5,343.5,179.1,343.2,179,342.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 179.4,
    y1: 342,
    x2: 178.7,
    y2: 340.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M178,340.1c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C178.6,340.8,178.1,340.6,178,340.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 178.4,
    y1: 339.4,
    x2: 177.8,
    y2: 337.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M177,337.4c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C177.6,338.2,177.2,337.9,177,337.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 177.4,
    y1: 336.7,
    x2: 176.8,
    y2: 334.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M176,334.8c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C176.6,335.5,176.2,335.2,176,334.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 176.4,
    y1: 334,
    x2: 175.8,
    y2: 332.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M175.1,332.1c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C175.6,332.8,175.2,332.6,175.1,332.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 175.5,
    y1: 331.4,
    x2: 174.8,
    y2: 329.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M174.1,329.4c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C174.6,330.1,174.2,329.9,174.1,329.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 174.5,
    y1: 328.7,
    x2: 173.8,
    y2: 326.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M173.1,326.8c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C173.7,327.5,173.3,327.2,173.1,326.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 173.5,
    y1: 326,
    x2: 172.9,
    y2: 324.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M172.1,324.1c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C172.7,324.8,172.3,324.5,172.1,324.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 172.5,
    y1: 323.3,
    x2: 171.9,
    y2: 321.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M171.1,321.4c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C171.7,322.1,171.3,321.9,171.1,321.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 171.6,
    y1: 320.7,
    x2: 170.9,
    y2: 318.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M170.2,318.8c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C170.7,319.5,170.3,319.2,170.2,318.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 170.6,
    y1: 318,
    x2: 169.9,
    y2: 316.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M169.2,316.1c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C169.8,316.8,169.4,316.5,169.2,316.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 169.6,
    y1: 315.3,
    x2: 169,
    y2: 313.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M168.2,313.4c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C168.8,314.1,168.4,313.9,168.2,313.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 168.6,
    y1: 312.7,
    x2: 168,
    y2: 310.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M167.2,310.7c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C167.8,311.5,167.4,311.2,167.2,310.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 167.7,
    y1: 310,
    x2: 167,
    y2: 308.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M166.3,308.1c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C166.8,308.8,166.4,308.5,166.3,308.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 166.7,
    y1: 307.3,
    x2: 166,
    y2: 305.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M165.3,305.4c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C165.9,306.1,165.5,305.9,165.3,305.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 165.7,
    y1: 304.7,
    x2: 165.1,
    y2: 302.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M148,350.8c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C147.5,351.5,147.9,351.2,148,350.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 147.6,
    y1: 350,
    x2: 148.3,
    y2: 348.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M149,348.1c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C148.4,348.8,148.8,348.6,149,348.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 148.6,
    y1: 347.4,
    x2: 149.2,
    y2: 345.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M150,345.5c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C149.4,346.2,149.8,345.9,150,345.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 149.6,
    y1: 344.7,
    x2: 150.2,
    y2: 342.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M151,342.8c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C150.4,343.5,150.8,343.2,151,342.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 150.5,
    y1: 342,
    x2: 151.2,
    y2: 340.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M151.9,340.1c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C151.4,340.8,151.8,340.6,151.9,340.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 151.5,
    y1: 339.4,
    x2: 152.2,
    y2: 337.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M152.9,337.4c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C152.3,338.2,152.7,337.9,152.9,337.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 152.5,
    y1: 336.7,
    x2: 153.1,
    y2: 334.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M153.9,334.8c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C153.3,335.5,153.7,335.2,153.9,334.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 153.5,
    y1: 334,
    x2: 154.1,
    y2: 332.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M154.9,332.1c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C154.3,332.8,154.7,332.6,154.9,332.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 154.4,
    y1: 331.4,
    x2: 155.1,
    y2: 329.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M155.8,329.4c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C155.3,330.1,155.7,329.9,155.8,329.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 155.4,
    y1: 328.7,
    x2: 156.1,
    y2: 326.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M156.8,326.8c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C156.2,327.5,156.7,327.2,156.8,326.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 156.4,
    y1: 326,
    x2: 157,
    y2: 324.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M157.8,324.1c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C157.2,324.8,157.6,324.5,157.8,324.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 157.4,
    y1: 323.3,
    x2: 158,
    y2: 321.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M158.8,321.4c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C158.2,322.1,158.6,321.9,158.8,321.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 158.3,
    y1: 320.7,
    x2: 159,
    y2: 318.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M159.7,318.8c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C159.2,319.5,159.6,319.2,159.7,318.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 159.3,
    y1: 318,
    x2: 160,
    y2: 316.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M160.7,316.1c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C160.1,316.8,160.6,316.5,160.7,316.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 160.3,
    y1: 315.3,
    x2: 160.9,
    y2: 313.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M161.7,313.4c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C161.1,314.1,161.5,313.9,161.7,313.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 161.3,
    y1: 312.7,
    x2: 161.9,
    y2: 310.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M162.7,310.7c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C162.1,311.5,162.5,311.2,162.7,310.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 162.2,
    y1: 310,
    x2: 162.9,
    y2: 308.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M163.6,308.1c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C163.1,308.8,163.5,308.5,163.6,308.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 163.2,
    y1: 307.3,
    x2: 163.9,
    y2: 305.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.6,305.4c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C164.1,306.1,164.5,305.9,164.6,305.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 164.2,
    y1: 304.7,
    x2: 164.9,
    y2: 302.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.3,352.5c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9 C164.6,353.3,164.3,353,164.3,352.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 165,
    y1: 351.9,
    x2: 165,
    y2: 350
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.3,349.6c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9 C164.6,350.5,164.3,350.1,164.3,349.6z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 165,
    y1: 349.1,
    x2: 165,
    y2: 347.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.3,346.8c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9 C164.6,347.7,164.3,347.3,164.3,346.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 165,
    y1: 346.2,
    x2: 165,
    y2: 344.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.3,343.9c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9 C164.6,344.8,164.3,344.4,164.3,343.9z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 165,
    y1: 343.4,
    x2: 165,
    y2: 341.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.3,341.1c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9 C164.6,342,164.3,341.6,164.3,341.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 165,
    y1: 340.5,
    x2: 165,
    y2: 338.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.3,338.3c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9 C164.6,339.1,164.3,338.7,164.3,338.3z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 165,
    y1: 337.7,
    x2: 165,
    y2: 335.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.3,335.4c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9 C164.6,336.3,164.3,335.9,164.3,335.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 165,
    y1: 334.9,
    x2: 165,
    y2: 333
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.3,332.6c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9 C164.6,333.4,164.3,333.1,164.3,332.6z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 165,
    y1: 332,
    x2: 165,
    y2: 330.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.3,329.7c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9 C164.6,330.6,164.3,330.2,164.3,329.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 165,
    y1: 329.2,
    x2: 165,
    y2: 327.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.3,326.9c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9 C164.6,327.8,164.3,327.4,164.3,326.9z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 165,
    y1: 326.3,
    x2: 165,
    y2: 324.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.3,324c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9s-0.3,0.9-0.7,0.9 C164.6,324.9,164.3,324.5,164.3,324z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 165,
    y1: 323.5,
    x2: 165,
    y2: 321.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.3,321.2c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9 C164.6,322.1,164.3,321.7,164.3,321.2z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 165,
    y1: 320.6,
    x2: 165,
    y2: 318.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.3,318.4c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9 C164.6,319.2,164.3,318.8,164.3,318.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 165,
    y1: 317.8,
    x2: 165,
    y2: 315.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.3,315.5c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9 C164.6,316.4,164.3,316,164.3,315.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 165,
    y1: 315,
    x2: 165,
    y2: 313.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.3,312.7c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9 C164.6,313.5,164.3,313.2,164.3,312.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 165,
    y1: 312.1,
    x2: 165,
    y2: 310.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.3,309.8c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9 C164.6,310.7,164.3,310.3,164.3,309.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 165,
    y1: 309.3,
    x2: 165,
    y2: 307.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.3,307c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9 C164.6,307.9,164.3,307.5,164.3,307z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 165,
    y1: 306.4,
    x2: 165,
    y2: 304.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.3,304.1c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9 C164.6,305,164.3,304.6,164.3,304.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 165,
    y1: 303.6,
    x2: 165,
    y2: 301.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.3,301.3c0-0.5,0.3-0.9,0.7-0.9c0.4,0,0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9 C164.6,302.2,164.3,301.8,164.3,301.3z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 165,
    y1: 300.7,
    x2: 165,
    y2: 298.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M145.4,350.5c0,1.4,8.7,3.6,19.5,3.6s19.5-2.2,19.5-3.6H145.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M184.5,350.5c0,1.4-8.7,3.6-19.5,3.6s-19.5-2.2-19.5-3.6H184.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M101.8,350.8c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C102.4,351.5,102,351.2,101.8,350.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 102.2,
    y1: 350,
    x2: 101.6,
    y2: 348.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M100.8,348.1c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C101.4,348.8,101,348.6,100.8,348.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 101.3,
    y1: 347.4,
    x2: 100.6,
    y2: 345.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M99.9,345.5c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C100.4,346.2,100,345.9,99.9,345.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 100.3,
    y1: 344.7,
    x2: 99.6,
    y2: 342.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M98.9,342.8c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C99.5,343.5,99,343.2,98.9,342.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 99.3,
    y1: 342,
    x2: 98.7,
    y2: 340.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M97.9,340.1c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C98.5,340.8,98.1,340.6,97.9,340.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 98.3,
    y1: 339.4,
    x2: 97.7,
    y2: 337.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M96.9,337.4c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C97.5,338.2,97.1,337.9,96.9,337.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 97.4,
    y1: 336.7,
    x2: 96.7,
    y2: 334.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M96,334.8c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C96.5,335.5,96.1,335.2,96,334.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 96.4,
    y1: 334,
    x2: 95.7,
    y2: 332.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M95,332.1c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C95.6,332.8,95.1,332.6,95,332.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 95.4,
    y1: 331.4,
    x2: 94.8,
    y2: 329.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M94,329.4c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C94.6,330.1,94.2,329.9,94,329.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 94.4,
    y1: 328.7,
    x2: 93.8,
    y2: 326.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M93,326.8c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C93.6,327.5,93.2,327.2,93,326.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 93.5,
    y1: 326,
    x2: 92.8,
    y2: 324.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M92.1,324.1c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C92.6,324.8,92.2,324.5,92.1,324.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 92.5,
    y1: 323.3,
    x2: 91.8,
    y2: 321.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M91.1,321.4c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C91.7,322.1,91.2,321.9,91.1,321.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 91.5,
    y1: 320.7,
    x2: 90.9,
    y2: 318.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M90.1,318.8c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C90.7,319.5,90.3,319.2,90.1,318.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 90.5,
    y1: 318,
    x2: 89.9,
    y2: 316.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M89.1,316.1c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C89.7,316.8,89.3,316.5,89.1,316.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 89.6,
    y1: 315.3,
    x2: 88.9,
    y2: 313.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M88.2,313.4c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C88.7,314.1,88.3,313.9,88.2,313.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 88.6,
    y1: 312.7,
    x2: 87.9,
    y2: 310.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M87.2,310.7c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C87.7,311.5,87.3,311.2,87.2,310.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 87.6,
    y1: 310,
    x2: 86.9,
    y2: 308.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M86.2,308.1c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C86.8,308.8,86.4,308.5,86.2,308.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 86.6,
    y1: 307.3,
    x2: 86,
    y2: 305.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M85.2,305.4c-0.2-0.5,0-0.9,0.3-1c0.3-0.1,0.7,0.1,0.9,0.6c0.2,0.5,0,0.9-0.3,1 C85.8,306.1,85.4,305.9,85.2,305.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 85.6,
    y1: 304.7,
    x2: 85,
    y2: 302.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M68,350.8c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C67.4,351.5,67.8,351.2,68,350.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 67.5,
    y1: 350,
    x2: 68.2,
    y2: 348.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M68.9,348.1c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C68.4,348.8,68.8,348.6,68.9,348.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 68.5,
    y1: 347.4,
    x2: 69.2,
    y2: 345.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M69.9,345.5c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C69.3,346.2,69.8,345.9,69.9,345.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 69.5,
    y1: 344.7,
    x2: 70.1,
    y2: 342.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M70.9,342.8c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C70.3,343.5,70.7,343.2,70.9,342.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 70.5,
    y1: 342,
    x2: 71.1,
    y2: 340.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M71.9,340.1c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C71.3,340.8,71.7,340.6,71.9,340.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 71.4,
    y1: 339.4,
    x2: 72.1,
    y2: 337.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M72.8,337.4c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C72.3,338.2,72.7,337.9,72.8,337.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 72.4,
    y1: 336.7,
    x2: 73.1,
    y2: 334.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M73.8,334.8c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C73.2,335.5,73.7,335.2,73.8,334.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 73.4,
    y1: 334,
    x2: 74,
    y2: 332.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M74.8,332.1c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C74.2,332.8,74.6,332.6,74.8,332.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 74.4,
    y1: 331.4,
    x2: 75,
    y2: 329.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M75.8,329.4c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C75.2,330.1,75.6,329.9,75.8,329.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 75.3,
    y1: 328.7,
    x2: 76,
    y2: 326.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M76.7,326.8c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C76.2,327.5,76.6,327.2,76.7,326.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 76.3,
    y1: 326,
    x2: 77,
    y2: 324.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M77.7,324.1c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C77.2,324.8,77.6,324.5,77.7,324.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 77.3,
    y1: 323.3,
    x2: 78,
    y2: 321.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M78.7,321.4c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C78.1,322.1,78.5,321.9,78.7,321.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 78.3,
    y1: 320.7,
    x2: 78.9,
    y2: 318.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M79.7,318.8c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C79.1,319.5,79.5,319.2,79.7,318.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 79.3,
    y1: 318,
    x2: 79.9,
    y2: 316.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M80.7,316.1c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C80.1,316.8,80.5,316.5,80.7,316.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 80.2,
    y1: 315.3,
    x2: 80.9,
    y2: 313.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M81.6,313.4c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C81.1,314.1,81.5,313.9,81.6,313.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 81.2,
    y1: 312.7,
    x2: 81.9,
    y2: 310.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M82.6,310.7c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C82,311.5,82.4,311.2,82.6,310.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 82.2,
    y1: 310,
    x2: 82.8,
    y2: 308.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M83.6,308.1c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C83,308.8,83.4,308.5,83.6,308.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 83.2,
    y1: 307.3,
    x2: 83.8,
    y2: 305.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.6,305.4c0.2-0.5,0-0.9-0.3-1c-0.3-0.1-0.7,0.1-0.9,0.6c-0.2,0.5,0,0.9,0.3,1 C84,306.1,84.4,305.9,84.6,305.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 84.1,
    y1: 304.7,
    x2: 84.8,
    y2: 302.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.2,352.5c0-0.5,0.3-0.9,0.7-0.9s0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9S84.2,353,84.2,352.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 84.9,
    y1: 351.9,
    x2: 84.9,
    y2: 350
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.2,349.6c0-0.5,0.3-0.9,0.7-0.9s0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9S84.2,350.1,84.2,349.6z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 84.9,
    y1: 349.1,
    x2: 84.9,
    y2: 347.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.2,346.8c0-0.5,0.3-0.9,0.7-0.9s0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9S84.2,347.3,84.2,346.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 84.9,
    y1: 346.2,
    x2: 84.9,
    y2: 344.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.2,343.9c0-0.5,0.3-0.9,0.7-0.9s0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9S84.2,344.4,84.2,343.9z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 84.9,
    y1: 343.4,
    x2: 84.9,
    y2: 341.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.2,341.1c0-0.5,0.3-0.9,0.7-0.9s0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9S84.2,341.6,84.2,341.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 84.9,
    y1: 340.5,
    x2: 84.9,
    y2: 338.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.2,338.3c0-0.5,0.3-0.9,0.7-0.9s0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9S84.2,338.7,84.2,338.3z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 84.9,
    y1: 337.7,
    x2: 84.9,
    y2: 335.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.2,335.4c0-0.5,0.3-0.9,0.7-0.9s0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9S84.2,335.9,84.2,335.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 84.9,
    y1: 334.9,
    x2: 84.9,
    y2: 333
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.2,332.6c0-0.5,0.3-0.9,0.7-0.9s0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9S84.2,333.1,84.2,332.6z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 84.9,
    y1: 332,
    x2: 84.9,
    y2: 330.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.2,329.7c0-0.5,0.3-0.9,0.7-0.9s0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9S84.2,330.2,84.2,329.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 84.9,
    y1: 329.2,
    x2: 84.9,
    y2: 327.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.2,326.9c0-0.5,0.3-0.9,0.7-0.9s0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9S84.2,327.4,84.2,326.9z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 84.9,
    y1: 326.3,
    x2: 84.9,
    y2: 324.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.2,324c0-0.5,0.3-0.9,0.7-0.9s0.7,0.4,0.7,0.9s-0.3,0.9-0.7,0.9S84.2,324.5,84.2,324z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 84.9,
    y1: 323.5,
    x2: 84.9,
    y2: 321.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.2,321.2c0-0.5,0.3-0.9,0.7-0.9s0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9S84.2,321.7,84.2,321.2z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 84.9,
    y1: 320.6,
    x2: 84.9,
    y2: 318.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.2,318.4c0-0.5,0.3-0.9,0.7-0.9s0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9S84.2,318.8,84.2,318.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 84.9,
    y1: 317.8,
    x2: 84.9,
    y2: 315.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.2,315.5c0-0.5,0.3-0.9,0.7-0.9s0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9S84.2,316,84.2,315.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 84.9,
    y1: 315,
    x2: 84.9,
    y2: 313.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.2,312.7c0-0.5,0.3-0.9,0.7-0.9s0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9S84.2,313.2,84.2,312.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 84.9,
    y1: 312.1,
    x2: 84.9,
    y2: 310.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.2,309.8c0-0.5,0.3-0.9,0.7-0.9s0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9S84.2,310.3,84.2,309.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 84.9,
    y1: 309.3,
    x2: 84.9,
    y2: 307.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.2,307c0-0.5,0.3-0.9,0.7-0.9s0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9S84.2,307.5,84.2,307z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 84.9,
    y1: 306.4,
    x2: 84.9,
    y2: 304.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.2,304.1c0-0.5,0.3-0.9,0.7-0.9s0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9S84.2,304.6,84.2,304.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 84.9,
    y1: 303.6,
    x2: 84.9,
    y2: 301.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M84.2,301.3c0-0.5,0.3-0.9,0.7-0.9s0.7,0.4,0.7,0.9c0,0.5-0.3,0.9-0.7,0.9S84.2,301.8,84.2,301.3z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 84.9,
    y1: 300.7,
    x2: 84.9,
    y2: 298.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M65.4,350.5c0,1.4,8.7,3.6,19.5,3.6s19.5-2.2,19.5-3.6H65.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M104.4,350.5c0,1.4-8.7,3.6-19.5,3.6s-19.5-2.2-19.5-3.6H104.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M124.8,291.2c0,0,0.7,0,1.8,0.1c0.3,0,0.6,0,1,0.1c0.4,0,0.8,0.1,1.2,0.1c0.4,0,0.9,0.1,1.3,0.2 c0.5,0.1,1,0.1,1.5,0.3c0.5,0.1,1,0.2,1.6,0.3c0.5,0.1,1.1,0.3,1.7,0.4c0.6,0.2,1.2,0.4,1.7,0.5c0.6,0.2,1.2,0.4,1.8,0.7 c1.2,0.5,2.4,1,3.6,1.6c1.2,0.6,2.4,1.2,3.6,1.8c1.2,0.6,2.4,1.2,3.5,1.8c1.2,0.5,2.3,1,3.5,1.3c1.2,0.3,2.3,0.5,3.4,0.6 c1.1,0.1,2.1,0.1,3.1-0.1c0.2,0,0.5-0.1,0.7-0.1c0.1,0,0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.3-0.1c0.2-0.1,0.4-0.1,0.6-0.2 c0.2-0.1,0.4-0.1,0.5-0.2c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2-0.1,0.2-0.1c0.2-0.1,0.3-0.2,0.5-0.2c0.3-0.2,0.5-0.3,0.7-0.5 c0.2-0.2,0.4-0.3,0.5-0.5c0.2-0.1,0.3-0.3,0.4-0.4c0.2-0.2,0.3-0.3,0.3-0.3l1,0.7c0,0-0.1,0.1-0.3,0.4c-0.1,0.1-0.2,0.3-0.4,0.5 c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3,0.2-0.5,0.4-0.9,0.6c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1 c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.4,0.1-0.7,0.2c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0.1-0.5,0.1-0.8,0.2 c-1,0.2-2.2,0.2-3.4,0.2c-1.2,0-2.5-0.2-3.7-0.5c-1.3-0.3-2.6-0.7-3.8-1.3c-1.2-0.5-2.5-1.1-3.7-1.7c-1.2-0.6-2.4-1.1-3.6-1.6 c-1.2-0.5-2.4-1-3.5-1.4c-0.6-0.2-1.2-0.4-1.7-0.5c-0.6-0.2-1.1-0.3-1.7-0.4c-0.5-0.1-1.1-0.2-1.6-0.4c-0.5-0.1-1-0.2-1.5-0.3 c-0.5-0.1-0.9-0.1-1.4-0.2c-0.4,0-0.9-0.1-1.2-0.1c-0.4,0-0.7,0-1.1-0.1c-0.3,0-0.6,0-0.9,0c-1.2,0-1.8,0-1.8,0L124.8,291.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M125.2,291.2c0,0-0.7,0-1.8,0.1c-0.3,0-0.6,0-1,0.1c-0.4,0-0.8,0.1-1.2,0.1c-0.4,0-0.9,0.1-1.3,0.2 c-0.5,0.1-1,0.1-1.5,0.3c-0.5,0.1-1,0.2-1.6,0.3c-0.5,0.1-1.1,0.3-1.7,0.4c-0.6,0.2-1.2,0.4-1.7,0.5c-0.6,0.2-1.2,0.4-1.8,0.7 c-1.2,0.5-2.4,1-3.6,1.6c-1.2,0.6-2.4,1.2-3.6,1.8c-1.2,0.6-2.4,1.2-3.5,1.8c-1.2,0.5-2.3,1-3.5,1.3c-1.2,0.3-2.3,0.5-3.4,0.6 c-1.1,0.1-2.1,0.1-3.1-0.1c-0.2,0-0.5-0.1-0.7-0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.4-0.1-0.6-0.2 c-0.2-0.1-0.4-0.1-0.5-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.2-0.1-0.3-0.2-0.5-0.2c-0.3-0.2-0.5-0.3-0.7-0.5 c-0.2-0.2-0.4-0.3-0.5-0.5c-0.2-0.1-0.3-0.3-0.4-0.4c-0.2-0.2-0.3-0.3-0.3-0.3l-1,0.7c0,0,0.1,0.1,0.3,0.4 c0.1,0.1,0.2,0.3,0.4,0.5c0.2,0.2,0.4,0.4,0.6,0.6c0.3,0.2,0.5,0.4,0.9,0.6c0.2,0.1,0.3,0.2,0.5,0.3c0.1,0,0.2,0.1,0.3,0.2 c0.1,0,0.2,0.1,0.3,0.1c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.1,0.4,0.1,0.7,0.2c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.2,0.1,0.4,0.1 c0.2,0.1,0.5,0.1,0.8,0.2c1,0.2,2.2,0.2,3.4,0.2c1.2,0,2.5-0.2,3.7-0.5c1.3-0.3,2.6-0.7,3.8-1.3c1.2-0.5,2.5-1.1,3.7-1.7 c1.2-0.6,2.4-1.1,3.6-1.6c1.2-0.5,2.4-1,3.5-1.4c0.6-0.2,1.2-0.4,1.7-0.5c0.6-0.2,1.1-0.3,1.7-0.4c0.5-0.1,1.1-0.2,1.6-0.4 c0.5-0.1,1-0.2,1.5-0.3c0.5-0.1,0.9-0.1,1.4-0.2c0.4,0,0.9-0.1,1.2-0.1c0.4,0,0.7,0,1.1-0.1c0.3,0,0.6,0,0.9,0c1.2,0,1.8,0,1.8,0 L125.2,291.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M124.8,291.2c0,0,0.7,0,1.8,0.1c0.3,0,0.6,0,1,0.1c0.4,0,0.8,0.1,1.2,0.1c0.4,0,0.9,0.1,1.3,0.2 c0.5,0.1,1,0.1,1.5,0.3c0.5,0.1,1,0.2,1.6,0.3c0.5,0.1,1.1,0.3,1.7,0.4c0.6,0.2,1.2,0.4,1.7,0.5c0.6,0.2,1.2,0.4,1.8,0.7 c1.2,0.5,2.4,1,3.6,1.6c1.2,0.6,2.4,1.2,3.6,1.8c1.2,0.6,2.4,1.2,3.5,1.8c1.2,0.5,2.3,1,3.5,1.3c1.2,0.3,2.3,0.5,3.4,0.6 c1.1,0.1,2.1,0.1,3.1-0.1c0.2,0,0.5-0.1,0.7-0.1c0.1,0,0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.3-0.1c0.2-0.1,0.4-0.1,0.6-0.2 c0.2-0.1,0.4-0.1,0.5-0.2c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2-0.1,0.2-0.1c0.2-0.1,0.3-0.2,0.5-0.2c0.3-0.2,0.5-0.3,0.7-0.5 c0.2-0.2,0.4-0.3,0.5-0.5c0.2-0.1,0.3-0.3,0.4-0.4c0.2-0.2,0.3-0.3,0.3-0.3l1,0.7c0,0-0.1,0.1-0.3,0.4c-0.1,0.1-0.2,0.3-0.4,0.5 c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3,0.2-0.5,0.4-0.9,0.6c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1 c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.4,0.1-0.7,0.2c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0.1-0.5,0.1-0.8,0.2 c-1,0.2-2.2,0.2-3.4,0.2c-1.2,0-2.5-0.2-3.7-0.5c-1.3-0.3-2.6-0.7-3.8-1.3c-1.2-0.5-2.5-1.1-3.7-1.7c-1.2-0.6-2.4-1.1-3.6-1.6 c-1.2-0.5-2.4-1-3.5-1.4c-0.6-0.2-1.2-0.4-1.7-0.5c-0.6-0.2-1.1-0.3-1.7-0.4c-0.5-0.1-1.1-0.2-1.6-0.4c-0.5-0.1-1-0.2-1.5-0.3 c-0.5-0.1-0.9-0.1-1.4-0.2c-0.4,0-0.9-0.1-1.2-0.1c-0.4,0-0.7,0-1.1-0.1c-0.3,0-0.6,0-0.9,0c-1.2,0-1.8,0-1.8,0L124.8,291.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M125.2,291.2c0,0-0.7,0-1.8,0.1c-0.3,0-0.6,0-1,0.1c-0.4,0-0.8,0.1-1.2,0.1c-0.4,0-0.9,0.1-1.3,0.2 c-0.5,0.1-1,0.1-1.5,0.3c-0.5,0.1-1,0.2-1.6,0.3c-0.5,0.1-1.1,0.3-1.7,0.4c-0.6,0.2-1.2,0.4-1.7,0.5c-0.6,0.2-1.2,0.4-1.8,0.7 c-1.2,0.5-2.4,1-3.6,1.6c-1.2,0.6-2.4,1.2-3.6,1.8c-1.2,0.6-2.4,1.2-3.5,1.8c-1.2,0.5-2.3,1-3.5,1.3c-1.2,0.3-2.3,0.5-3.4,0.6 c-1.1,0.1-2.1,0.1-3.1-0.1c-0.2,0-0.5-0.1-0.7-0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.4-0.1-0.6-0.2 c-0.2-0.1-0.4-0.1-0.5-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.2-0.1-0.3-0.2-0.5-0.2c-0.3-0.2-0.5-0.3-0.7-0.5 c-0.2-0.2-0.4-0.3-0.5-0.5c-0.2-0.1-0.3-0.3-0.4-0.4c-0.2-0.2-0.3-0.3-0.3-0.3l-1,0.7c0,0,0.1,0.1,0.3,0.4 c0.1,0.1,0.2,0.3,0.4,0.5c0.2,0.2,0.4,0.4,0.6,0.6c0.3,0.2,0.5,0.4,0.9,0.6c0.2,0.1,0.3,0.2,0.5,0.3c0.1,0,0.2,0.1,0.3,0.2 c0.1,0,0.2,0.1,0.3,0.1c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.1,0.4,0.1,0.7,0.2c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.2,0.1,0.4,0.1 c0.2,0.1,0.5,0.1,0.8,0.2c1,0.2,2.2,0.2,3.4,0.2c1.2,0,2.5-0.2,3.7-0.5c1.3-0.3,2.6-0.7,3.8-1.3c1.2-0.5,2.5-1.1,3.7-1.7 c1.2-0.6,2.4-1.1,3.6-1.6c1.2-0.5,2.4-1,3.5-1.4c0.6-0.2,1.2-0.4,1.7-0.5c0.6-0.2,1.1-0.3,1.7-0.4c0.5-0.1,1.1-0.2,1.6-0.4 c0.5-0.1,1-0.2,1.5-0.3c0.5-0.1,0.9-0.1,1.4-0.2c0.4,0,0.9-0.1,1.2-0.1c0.4,0,0.7,0,1.1-0.1c0.3,0,0.6,0,0.9,0c1.2,0,1.8,0,1.8,0 L125.2,291.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: 164.8,
    cy: 298.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M84.7,297.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C85.9,297.9,85.4,297.4,84.7,297.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M128.6,288.9c0-2.1-1.7-3.8-3.8-3.8c-2.1,0-3.8,1.7-3.8,3.8c0,0.9,0.3,1.5,0.8,2.2l0.3,7.3h5.4l0.3-7.3 C128.3,290.5,128.6,289.8,128.6,288.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M121.8,291.3h6l0,0c0.5-0.6,0.8-1.3,0.8-2.2c0-2.1-1.7-3.8-3.8-3.8c-2.1,0-3.8,1.7-3.8,3.8 C121,290,121.3,290.7,121.8,291.3L121.8,291.3z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M542.8,174.8v-16.1h7.7c1.3,0,2.4,0.2,3.2,0.7c0.8,0.5,1.4,1.1,1.7,1.9c0.3,0.8,0.5,1.6,0.5,2.5 c0,0.6-0.1,1.2-0.3,1.8c-0.2,0.6-0.6,1.2-1,1.7c-0.5,0.5-1,0.9-1.7,1.1l3.1,6.3h-3.7l-3-5.8h-3.2v5.8H542.8z M546.1,165.9h4.4 c0.5,0,0.9-0.1,1.2-0.3c0.3-0.2,0.5-0.4,0.6-0.8c0.1-0.3,0.2-0.6,0.2-1c0-0.3-0.1-0.6-0.2-0.9s-0.3-0.6-0.6-0.8 c-0.3-0.2-0.7-0.3-1.2-0.3h-4.4V165.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M558.8,174.8v-16.1h11.3v3.1h-8v3.1h4.6v3.1h-4.6v3.6h8.5v3.2H558.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M579.5,175.1c-1.2,0-2.3-0.2-3.2-0.7c-0.9-0.5-1.6-1.1-2.2-1.9s-1-1.7-1.3-2.7c-0.3-1-0.4-2-0.4-3.1 c0-1,0.1-2,0.4-2.9c0.3-1,0.7-1.9,1.3-2.7c0.6-0.8,1.3-1.5,2.2-2c0.9-0.5,1.9-0.7,3.2-0.7c1,0,1.9,0.2,2.6,0.5 c0.7,0.3,1.3,0.8,1.9,1.3c0.5,0.5,1,1.1,1.3,1.7l-2.9,1.6c-0.4-0.6-0.8-1-1.2-1.4s-1-0.6-1.7-0.6c-0.7,0-1.3,0.2-1.7,0.5 c-0.5,0.3-0.8,0.7-1.1,1.3c-0.3,0.5-0.5,1.1-0.6,1.7c-0.1,0.6-0.2,1.2-0.2,1.8c0,0.7,0.1,1.3,0.2,1.9c0.1,0.6,0.4,1.2,0.6,1.7 c0.3,0.5,0.7,0.9,1.1,1.2c0.5,0.3,1,0.4,1.7,0.4c0.5,0,0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.5,0.9-0.9c0.2-0.4,0.4-0.7,0.4-1.2v-0.2h-2.7 v-3.2h6.1v2.4c0,1.4-0.3,2.5-0.8,3.5c-0.5,1-1.2,1.7-2.2,2.2C581.6,174.8,580.6,175.1,579.5,175.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M588.6,174.8v-16.1h3.3v16.1H588.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M600.9,175.1c-1,0-2-0.2-2.8-0.6c-0.8-0.4-1.6-0.9-2.2-1.6c-0.6-0.7-1.1-1.5-1.4-2.4l3-1.1 c0.4,0.8,0.8,1.4,1.4,1.8s1.3,0.7,2,0.7c0.8,0,1.4-0.2,1.8-0.5s0.7-0.8,0.7-1.3c0-0.4-0.1-0.7-0.4-1s-0.6-0.5-1.1-0.7 c-0.5-0.2-1-0.4-1.6-0.6c-0.6-0.2-1.2-0.4-1.8-0.7c-0.6-0.2-1.2-0.5-1.7-0.9c-0.5-0.4-0.9-0.8-1.2-1.4c-0.3-0.6-0.5-1.2-0.5-2.1 c0-0.8,0.2-1.6,0.6-2.2c0.4-0.7,1.1-1.2,1.9-1.6c0.8-0.4,1.8-0.6,3-0.6c1,0,1.8,0.2,2.6,0.5c0.8,0.3,1.4,0.8,1.9,1.4 c0.5,0.6,0.8,1.2,1,2l-2.9,1c-0.2-0.5-0.5-0.9-1-1.2c-0.4-0.3-1-0.5-1.7-0.5c-0.7,0-1.2,0.1-1.5,0.4c-0.4,0.2-0.5,0.6-0.5,1.1 c0,0.3,0.1,0.6,0.4,0.8c0.2,0.2,0.6,0.4,1,0.6c0.4,0.2,0.9,0.3,1.5,0.5c0.7,0.2,1.3,0.5,2,0.7s1.2,0.6,1.8,1c0.5,0.4,1,0.9,1.3,1.5 c0.3,0.6,0.5,1.3,0.5,2.2c0,1-0.3,1.9-0.8,2.6c-0.5,0.7-1.2,1.3-2.1,1.7C603.1,174.9,602,175.1,600.9,175.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M612.8,174.8v-12.9h-4.6v-3.2h12.5v3.2h-4.6v12.9H612.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M623.2,174.8v-16.1h7.7c1.3,0,2.4,0.2,3.2,0.7c0.8,0.5,1.4,1.1,1.7,1.9c0.3,0.8,0.5,1.6,0.5,2.5 c0,0.6-0.1,1.2-0.3,1.8c-0.2,0.6-0.6,1.2-1,1.7c-0.5,0.5-1,0.9-1.7,1.1l3.1,6.3h-3.7l-3-5.8h-3.2v5.8H623.2z M626.5,165.9h4.4 c0.5,0,0.9-0.1,1.2-0.3c0.3-0.2,0.5-0.4,0.6-0.8c0.1-0.3,0.2-0.6,0.2-1c0-0.3-0.1-0.6-0.2-0.9s-0.3-0.6-0.6-0.8 c-0.3-0.2-0.7-0.3-1.2-0.3h-4.4V165.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M645.8,175.1c-1.3,0-2.4-0.2-3.3-0.7c-0.9-0.5-1.6-1.1-2.2-1.9c-0.6-0.8-1-1.7-1.2-2.7s-0.4-2-0.4-3 s0.1-2,0.4-3c0.3-1,0.7-1.9,1.2-2.7c0.6-0.8,1.3-1.5,2.2-1.9c0.9-0.5,2-0.7,3.3-0.7c1.3,0,2.4,0.2,3.3,0.7c0.9,0.5,1.6,1.1,2.2,1.9 s1,1.7,1.2,2.7c0.3,1,0.4,2,0.4,3s-0.1,2-0.4,3s-0.7,1.9-1.2,2.7c-0.6,0.8-1.3,1.5-2.2,1.9C648.2,174.8,647.1,175.1,645.8,175.1z  M645.8,171.9c0.7,0,1.2-0.2,1.7-0.5c0.5-0.3,0.8-0.7,1.1-1.2c0.3-0.5,0.5-1.1,0.6-1.7c0.1-0.6,0.2-1.2,0.2-1.7 c0-0.6-0.1-1.2-0.2-1.8c-0.1-0.6-0.3-1.2-0.6-1.7s-0.7-0.9-1.1-1.2c-0.5-0.3-1-0.5-1.7-0.5c-0.7,0-1.3,0.2-1.7,0.5 c-0.5,0.3-0.8,0.7-1.1,1.2c-0.3,0.5-0.5,1.1-0.6,1.7c-0.1,0.6-0.2,1.2-0.2,1.7c0,0.6,0.1,1.2,0.2,1.8c0.1,0.6,0.3,1.2,0.6,1.7 c0.3,0.5,0.7,0.9,1.1,1.2S645.1,171.9,645.8,171.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M574.6,202.4v-16.1h3l6.1,8.8c0.1,0.1,0.2,0.3,0.3,0.6c0.1,0.2,0.3,0.5,0.3,0.6c0-0.2,0-0.4-0.1-0.6 c0-0.3,0-0.5,0-0.6v-8.8h3.3v16.1h-2.9l-6.2-8.9c-0.1-0.1-0.2-0.3-0.3-0.6s-0.3-0.5-0.3-0.7c0,0.2,0,0.4,0.1,0.6c0,0.2,0,0.4,0,0.6 v8.9H574.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M589.8,202.4l6.3-16.1h3.2l6.3,16.1h-3.6l-1.2-3.2h-6.1l-1.2,3.2H589.8z M599.5,184.6c-0.4,0-0.8-0.1-1.2-0.2 s-0.7-0.3-1-0.4c-0.3-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.5-0.1-0.8-0.1c-0.3,0-0.5,0.1-0.8,0.2c-0.2,0.1-0.3,0.4-0.3,0.8h-1.5 c0-0.6,0.1-1.1,0.3-1.6s0.5-0.9,0.9-1.1c0.4-0.3,0.9-0.4,1.6-0.4c0.4,0,0.8,0.1,1.2,0.2c0.4,0.1,0.7,0.2,1,0.4 c0.3,0.1,0.5,0.2,0.8,0.3c0.3,0.1,0.5,0.1,0.8,0.1c0.3,0,0.5-0.1,0.8-0.2c0.2-0.1,0.3-0.4,0.3-0.7h1.4c0,0.6-0.1,1.1-0.3,1.6 c-0.2,0.5-0.5,0.9-0.8,1.2C600.7,184.5,600.1,184.6,599.5,184.6z M595.7,196.1h3.9l-1.5-3.8c0-0.1-0.1-0.2-0.2-0.4 c-0.1-0.1-0.1-0.3-0.2-0.5c-0.1-0.2-0.1-0.3-0.1-0.4c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.1,0.3-0.2,0.4 L595.7,196.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M613.9,202.7c-1.3,0-2.4-0.2-3.3-0.7c-0.9-0.5-1.6-1.1-2.2-1.9c-0.6-0.8-1-1.7-1.2-2.7s-0.4-2-0.4-3 s0.1-2,0.4-3c0.3-1,0.7-1.9,1.2-2.7c0.6-0.8,1.3-1.5,2.2-1.9c0.9-0.5,2-0.7,3.3-0.7c1.3,0,2.4,0.2,3.3,0.7c0.9,0.5,1.6,1.1,2.2,1.9 s1,1.7,1.2,2.7c0.3,1,0.4,2,0.4,3s-0.1,2-0.4,3s-0.7,1.9-1.2,2.7c-0.6,0.8-1.3,1.5-2.2,1.9C616.3,202.4,615.2,202.7,613.9,202.7z  M613.9,199.5c0.7,0,1.2-0.2,1.7-0.5c0.5-0.3,0.8-0.7,1.1-1.2c0.3-0.5,0.5-1.1,0.6-1.7c0.1-0.6,0.2-1.2,0.2-1.7 c0-0.6-0.1-1.2-0.2-1.8c-0.1-0.6-0.3-1.2-0.6-1.7s-0.7-0.9-1.1-1.2c-0.5-0.3-1-0.5-1.7-0.5c-0.7,0-1.3,0.2-1.7,0.5 c-0.5,0.3-0.8,0.7-1.1,1.2c-0.3,0.5-0.5,1.1-0.6,1.7c-0.1,0.6-0.2,1.2-0.2,1.7c0,0.6,0.1,1.2,0.2,1.8c0.1,0.6,0.3,1.2,0.6,1.7 c0.3,0.5,0.7,0.9,1.1,1.2S613.3,199.5,613.9,199.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M517.3,230v-16.1h11.3v3.1h-8v3.1h4.6v3.1h-4.6v3.6h8.5v3.2H517.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M531.8,230v-16.1h3l6.1,8.8c0.1,0.1,0.2,0.3,0.3,0.6c0.1,0.2,0.3,0.5,0.3,0.6c0-0.2,0-0.4-0.1-0.6 c0-0.3,0-0.5,0-0.6v-8.8h3.3V230h-2.9l-6.2-8.9c-0.1-0.1-0.2-0.3-0.3-0.6s-0.3-0.5-0.3-0.7c0,0.2,0,0.4,0.1,0.6c0,0.2,0,0.4,0,0.6 v8.9H531.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M554.6,230.2c-1.3,0-2.3-0.2-3.2-0.7s-1.6-1.1-2.1-1.9c-0.5-0.8-0.9-1.7-1.1-2.7c-0.2-1-0.4-2-0.4-3 c0-0.9,0.1-1.9,0.4-2.9c0.2-1,0.6-1.9,1.2-2.7c0.5-0.8,1.2-1.5,2.1-2c0.9-0.5,1.9-0.8,3.2-0.8c1,0,1.9,0.2,2.7,0.5s1.4,0.8,1.9,1.4 c0.5,0.6,0.9,1.2,1.2,1.8l-2.9,1.3c-0.3-0.4-0.5-0.7-0.8-1c-0.3-0.3-0.6-0.5-0.9-0.7c-0.3-0.2-0.7-0.2-1.1-0.2 c-0.6,0-1.2,0.2-1.6,0.5c-0.4,0.3-0.8,0.7-1,1.2s-0.4,1.1-0.6,1.7c-0.1,0.6-0.2,1.2-0.2,1.8c0,0.6,0.1,1.2,0.2,1.8 c0.1,0.6,0.3,1.2,0.6,1.7c0.3,0.5,0.6,0.9,1,1.2c0.4,0.3,0.9,0.5,1.5,0.5c0.6,0,1.1-0.2,1.6-0.6c0.5-0.4,0.9-0.9,1.2-1.5l3,1.1 c-0.4,0.8-0.8,1.5-1.4,2.1c-0.5,0.6-1.2,1.1-1.9,1.5C556.4,230.1,555.6,230.2,554.6,230.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M569.1,230.3c-1.3,0-2.4-0.2-3.3-0.7c-0.9-0.5-1.6-1.1-2.2-1.9c-0.6-0.8-1-1.7-1.2-2.7s-0.4-2-0.4-3 s0.1-2,0.4-3c0.3-1,0.7-1.9,1.2-2.7c0.6-0.8,1.3-1.5,2.2-1.9c0.9-0.5,2-0.7,3.3-0.7c1.3,0,2.4,0.2,3.3,0.7c0.9,0.5,1.6,1.1,2.2,1.9 s1,1.7,1.2,2.7c0.3,1,0.4,2,0.4,3s-0.1,2-0.4,3s-0.7,1.9-1.2,2.7c-0.6,0.8-1.3,1.5-2.2,1.9C571.5,230,570.4,230.3,569.1,230.3z  M569.1,227.1c0.7,0,1.2-0.2,1.7-0.5c0.5-0.3,0.8-0.7,1.1-1.2c0.3-0.5,0.5-1.1,0.6-1.7c0.1-0.6,0.2-1.2,0.2-1.7 c0-0.6-0.1-1.2-0.2-1.8c-0.1-0.6-0.3-1.2-0.6-1.7s-0.7-0.9-1.1-1.2c-0.5-0.3-1-0.5-1.7-0.5c-0.7,0-1.3,0.2-1.7,0.5 c-0.5,0.3-0.8,0.7-1.1,1.2c-0.3,0.5-0.5,1.1-0.6,1.7c-0.1,0.6-0.2,1.2-0.2,1.7c0,0.6,0.1,1.2,0.2,1.8c0.1,0.6,0.3,1.2,0.6,1.7 c0.3,0.5,0.7,0.9,1.1,1.2S568.4,227.1,569.1,227.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M579.1,230v-16.1h3l6.1,8.8c0.1,0.1,0.2,0.3,0.3,0.6c0.1,0.2,0.3,0.5,0.3,0.6c0-0.2,0-0.4-0.1-0.6 c0-0.3,0-0.5,0-0.6v-8.8h3.3V230h-2.9l-6.2-8.9c-0.1-0.1-0.2-0.3-0.3-0.6s-0.3-0.5-0.3-0.7c0,0.2,0,0.4,0.1,0.6c0,0.2,0,0.4,0,0.6 v8.9H579.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M599.2,230v-12.9h-4.6v-3.2h12.5v3.2h-4.6V230H599.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M609.6,230v-16.1h7.7c1.3,0,2.4,0.2,3.2,0.7c0.8,0.5,1.4,1.1,1.7,1.9c0.3,0.8,0.5,1.6,0.5,2.5 c0,0.6-0.1,1.2-0.3,1.8c-0.2,0.6-0.6,1.2-1,1.7c-0.5,0.5-1,0.9-1.7,1.1l3.1,6.3h-3.7l-3-5.8h-3.2v5.8H609.6z M612.9,221.1h4.4 c0.5,0,0.9-0.1,1.2-0.3c0.3-0.2,0.5-0.4,0.6-0.8c0.1-0.3,0.2-0.6,0.2-1c0-0.3-0.1-0.6-0.2-0.9s-0.3-0.6-0.6-0.8 c-0.3-0.2-0.7-0.3-1.2-0.3h-4.4V221.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M624.2,230l6.3-16.1h3.2l6.3,16.1h-3.6l-1.2-3.2H629l-1.2,3.2H624.2z M630.1,223.7h3.9l-1.5-3.8 c0-0.1-0.1-0.2-0.2-0.4c-0.1-0.1-0.1-0.3-0.2-0.5c-0.1-0.2-0.1-0.3-0.1-0.4c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.5 c-0.1,0.1-0.1,0.3-0.2,0.4L630.1,223.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M642.1,230v-16.1h5.8c1.4,0,2.6,0.2,3.6,0.7c1,0.5,1.8,1.1,2.4,1.8s1.1,1.6,1.4,2.6c0.3,1,0.4,1.9,0.4,2.9 c0,0.9-0.1,1.8-0.4,2.8c-0.3,0.9-0.7,1.8-1.3,2.6c-0.6,0.8-1.4,1.4-2.4,1.9c-1,0.5-2.2,0.7-3.7,0.7H642.1z M645.4,226.9h2.7 c0.8,0,1.4-0.1,1.9-0.4c0.5-0.3,0.9-0.7,1.3-1.2s0.6-1,0.7-1.6c0.1-0.6,0.2-1.1,0.2-1.7c0-0.6-0.1-1.2-0.2-1.8s-0.4-1.1-0.7-1.6 c-0.3-0.5-0.7-0.9-1.2-1.1s-1.1-0.4-1.7-0.4h-2.9V226.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M665.1,230.3c-1.3,0-2.4-0.2-3.3-0.7c-0.9-0.5-1.6-1.1-2.2-1.9c-0.6-0.8-1-1.7-1.2-2.7s-0.4-2-0.4-3 s0.1-2,0.4-3c0.3-1,0.7-1.9,1.2-2.7c0.6-0.8,1.3-1.5,2.2-1.9c0.9-0.5,2-0.7,3.3-0.7c1.3,0,2.4,0.2,3.3,0.7c0.9,0.5,1.6,1.1,2.2,1.9 s1,1.7,1.2,2.7c0.3,1,0.4,2,0.4,3s-0.1,2-0.4,3s-0.7,1.9-1.2,2.7c-0.6,0.8-1.3,1.5-2.2,1.9C667.5,230,666.4,230.3,665.1,230.3z  M665.1,227.1c0.7,0,1.2-0.2,1.7-0.5c0.5-0.3,0.8-0.7,1.1-1.2c0.3-0.5,0.5-1.1,0.6-1.7c0.1-0.6,0.2-1.2,0.2-1.7 c0-0.6-0.1-1.2-0.2-1.8c-0.1-0.6-0.3-1.2-0.6-1.7s-0.7-0.9-1.1-1.2c-0.5-0.3-1-0.5-1.7-0.5c-0.7,0-1.3,0.2-1.7,0.5 c-0.5,0.3-0.8,0.7-1.1,1.2c-0.3,0.5-0.5,1.1-0.6,1.7c-0.1,0.6-0.2,1.2-0.2,1.7c0,0.6,0.1,1.2,0.2,1.8c0.1,0.6,0.3,1.2,0.6,1.7 c0.3,0.5,0.7,0.9,1.1,1.2S664.4,227.1,665.1,227.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M676.6,230.3c-0.6,0-1-0.2-1.4-0.6c-0.4-0.4-0.6-0.8-0.6-1.4c0-0.5,0.2-1,0.6-1.4c0.4-0.4,0.9-0.6,1.4-0.6 s1,0.2,1.4,0.6c0.4,0.4,0.6,0.9,0.6,1.4c0,0.6-0.2,1-0.6,1.4C677.6,230.1,677.2,230.3,676.6,230.3z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M538.6,176.8v-21h10c1.8,0,3.2,0.3,4.2,0.9c1,0.6,1.8,1.4,2.2,2.4c0.4,1,0.7,2.1,0.7,3.3 c0,0.8-0.1,1.6-0.4,2.4s-0.7,1.5-1.3,2.2s-1.3,1.2-2.2,1.5l4,8.3h-4.8l-3.9-7.6h-4.1v7.6H538.6z M542.9,165.2h5.7 c0.6,0,1.1-0.1,1.5-0.4s0.6-0.6,0.8-1c0.2-0.4,0.2-0.8,0.2-1.3c0-0.4-0.1-0.8-0.2-1.2c-0.1-0.4-0.4-0.7-0.8-1 c-0.4-0.3-0.9-0.4-1.6-0.4h-5.7V165.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M559.5,176.8v-21h14.8v4.1h-10.4v4h6v4.1h-6v4.7h11.1v4.1H559.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M586,177.1c-1.7,0-3-0.3-4.2-0.9c-1.1-0.6-2-1.5-2.7-2.5c-0.7-1-1.2-2.2-1.5-3.5c-0.3-1.3-0.5-2.6-0.5-3.9 c0-1.2,0.2-2.5,0.5-3.7c0.3-1.3,0.8-2.4,1.5-3.5c0.7-1.1,1.6-2,2.7-2.6c1.1-0.7,2.5-1,4.1-1c1.3,0,2.5,0.2,3.5,0.7 c1,0.5,1.9,1.1,2.5,1.8c0.7,0.7,1.2,1.5,1.5,2.4l-3.8,1.7c-0.3-0.5-0.7-1-1-1.3c-0.4-0.4-0.7-0.7-1.2-0.9c-0.4-0.2-0.9-0.3-1.5-0.3 c-0.8,0-1.5,0.2-2.1,0.6c-0.6,0.4-1,1-1.3,1.6s-0.6,1.4-0.7,2.2c-0.1,0.8-0.2,1.6-0.2,2.3c0,0.8,0.1,1.6,0.3,2.4s0.4,1.5,0.8,2.2 c0.3,0.6,0.8,1.2,1.4,1.6c0.6,0.4,1.2,0.6,2,0.6c0.8,0,1.5-0.3,2.1-0.8s1.1-1.2,1.6-1.9l3.9,1.5c-0.5,1-1.1,2-1.8,2.8 c-0.7,0.8-1.5,1.4-2.5,1.9C588.4,176.9,587.3,177.1,586,177.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M605,177.2c-1.7,0-3.1-0.3-4.3-1c-1.2-0.6-2.1-1.5-2.9-2.5s-1.3-2.2-1.6-3.5s-0.5-2.6-0.5-3.9 c0-1.3,0.2-2.6,0.5-3.9c0.3-1.3,0.9-2.4,1.6-3.5c0.7-1.1,1.7-1.9,2.9-2.5c1.2-0.6,2.6-1,4.3-1c1.7,0,3.1,0.3,4.3,1 c1.2,0.6,2.1,1.5,2.8,2.5c0.7,1.1,1.3,2.2,1.6,3.5c0.3,1.3,0.5,2.6,0.5,3.9c0,1.3-0.2,2.6-0.5,3.9s-0.9,2.4-1.6,3.5 c-0.7,1.1-1.7,1.9-2.8,2.5C608.1,176.9,606.7,177.2,605,177.2z M605,173c0.9,0,1.6-0.2,2.2-0.6s1.1-1,1.5-1.6 c0.4-0.7,0.6-1.4,0.8-2.2c0.2-0.8,0.3-1.5,0.3-2.3c0-0.8-0.1-1.6-0.2-2.4c-0.2-0.8-0.4-1.5-0.8-2.2c-0.4-0.7-0.9-1.2-1.5-1.6 c-0.6-0.4-1.4-0.6-2.3-0.6c-0.9,0-1.7,0.2-2.3,0.6c-0.6,0.4-1.1,1-1.5,1.6c-0.4,0.7-0.6,1.4-0.8,2.2c-0.2,0.8-0.2,1.5-0.2,2.3 c0,0.8,0.1,1.5,0.2,2.3s0.4,1.5,0.8,2.2s0.9,1.2,1.5,1.6C603.4,172.8,604.1,173,605,173z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M618,176.8v-21h10c1.8,0,3.2,0.3,4.2,0.9c1,0.6,1.8,1.4,2.2,2.4c0.4,1,0.7,2.1,0.7,3.3c0,0.8-0.1,1.6-0.4,2.4 s-0.7,1.5-1.3,2.2s-1.3,1.2-2.2,1.5l4,8.3h-4.8l-3.9-7.6h-4.1v7.6H618z M622.3,165.2h5.7c0.6,0,1.1-0.1,1.5-0.4s0.6-0.6,0.8-1 c0.2-0.4,0.2-0.8,0.2-1.3c0-0.4-0.1-0.8-0.2-1.2c-0.1-0.4-0.4-0.7-0.8-1c-0.4-0.3-0.9-0.4-1.6-0.4h-5.7V165.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M638.9,176.8v-21h7.5c1.8,0,3.4,0.3,4.7,0.9c1.3,0.6,2.3,1.4,3.2,2.4c0.8,1,1.4,2.1,1.8,3.4s0.6,2.5,0.6,3.8 c0,1.2-0.2,2.4-0.5,3.6c-0.4,1.2-0.9,2.4-1.7,3.4s-1.8,1.9-3.2,2.5c-1.3,0.6-2.9,1-4.9,1H638.9z M643.3,172.7h3.5 c1,0,1.8-0.2,2.5-0.6c0.7-0.4,1.2-0.9,1.7-1.5c0.4-0.6,0.7-1.3,0.9-2.1c0.2-0.8,0.3-1.5,0.3-2.2c0-0.8-0.1-1.5-0.3-2.3 c-0.2-0.8-0.5-1.4-0.9-2.1s-0.9-1.1-1.6-1.5c-0.6-0.4-1.4-0.6-2.3-0.6h-3.8V172.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M568.9,212.8v-21h4l7.9,11.5c0.1,0.2,0.2,0.4,0.4,0.7c0.2,0.3,0.3,0.6,0.4,0.8c0-0.2-0.1-0.5-0.1-0.8 c0-0.3,0-0.6,0-0.8v-11.5h4.3v21h-3.8l-8.1-11.6c-0.1-0.2-0.3-0.4-0.4-0.7c-0.2-0.3-0.3-0.6-0.4-0.9c0,0.3,0.1,0.5,0.1,0.8 c0,0.3,0,0.5,0,0.8v11.6H568.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M598.9,213.2c-1.7,0-3.1-0.3-4.3-1c-1.2-0.6-2.1-1.5-2.9-2.5s-1.3-2.2-1.6-3.5s-0.5-2.6-0.5-3.9 c0-1.3,0.2-2.6,0.5-3.9c0.3-1.3,0.9-2.4,1.6-3.5c0.7-1.1,1.7-1.9,2.9-2.5c1.2-0.6,2.6-1,4.3-1c1.7,0,3.1,0.3,4.3,1 c1.2,0.6,2.1,1.5,2.8,2.5c0.7,1.1,1.3,2.2,1.6,3.5c0.3,1.3,0.5,2.6,0.5,3.9c0,1.3-0.2,2.6-0.5,3.9s-0.9,2.4-1.6,3.5 c-0.7,1.1-1.7,1.9-2.8,2.5C602.1,212.9,600.6,213.2,598.9,213.2z M598.9,209c0.9,0,1.6-0.2,2.2-0.6s1.1-1,1.5-1.6 c0.4-0.7,0.6-1.4,0.8-2.2c0.2-0.8,0.3-1.5,0.3-2.3c0-0.8-0.1-1.6-0.2-2.4c-0.2-0.8-0.4-1.5-0.8-2.2c-0.4-0.7-0.9-1.2-1.5-1.6 c-0.6-0.4-1.4-0.6-2.3-0.6c-0.9,0-1.7,0.2-2.3,0.6c-0.6,0.4-1.1,1-1.5,1.6c-0.4,0.7-0.6,1.4-0.8,2.2c-0.2,0.8-0.2,1.5-0.2,2.3 c0,0.8,0.1,1.5,0.2,2.3s0.4,1.5,0.8,2.2s0.9,1.2,1.5,1.6C597.3,208.8,598,209,598.9,209z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M616,212.8V196h-6v-4.1h16.3v4.1h-6v16.9H616z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M543.7,248.8v-21h14.4v4.1H548v4h6.4v4.1H548v8.8H543.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M569.5,249.2c-1.7,0-3.1-0.3-4.3-1c-1.2-0.6-2.1-1.5-2.9-2.5s-1.3-2.2-1.6-3.5s-0.5-2.6-0.5-3.9 c0-1.3,0.2-2.6,0.5-3.9c0.3-1.3,0.9-2.4,1.6-3.5c0.7-1.1,1.7-1.9,2.9-2.5c1.2-0.6,2.6-1,4.3-1c1.7,0,3.1,0.3,4.3,1 c1.2,0.6,2.1,1.5,2.8,2.5c0.7,1.1,1.3,2.2,1.6,3.5c0.3,1.3,0.5,2.6,0.5,3.9c0,1.3-0.2,2.6-0.5,3.9s-0.9,2.4-1.6,3.5 c-0.7,1.1-1.7,1.9-2.8,2.5C572.7,248.9,571.2,249.2,569.5,249.2z M569.5,245c0.9,0,1.6-0.2,2.2-0.6s1.1-1,1.5-1.6 c0.4-0.7,0.6-1.4,0.8-2.2c0.2-0.8,0.3-1.5,0.3-2.3c0-0.8-0.1-1.6-0.2-2.4c-0.2-0.8-0.4-1.5-0.8-2.2c-0.4-0.7-0.9-1.2-1.5-1.6 c-0.6-0.4-1.4-0.6-2.3-0.6c-0.9,0-1.7,0.2-2.3,0.6c-0.6,0.4-1.1,1-1.5,1.6c-0.4,0.7-0.6,1.4-0.8,2.2c-0.2,0.8-0.2,1.5-0.2,2.3 c0,0.8,0.1,1.5,0.2,2.3s0.4,1.5,0.8,2.2s0.9,1.2,1.5,1.6C567.9,244.8,568.7,245,569.5,245z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M591.1,249.2c-1.8,0-3.3-0.3-4.6-1c-1.3-0.7-2.3-1.6-3-2.9c-0.7-1.3-1-2.8-1-4.6v-12.9h4.3v12.9 c0,1.5,0.3,2.6,1,3.3c0.7,0.7,1.8,1,3.3,1c0.9,0,1.7-0.1,2.4-0.4c0.6-0.3,1.1-0.7,1.4-1.3c0.3-0.6,0.5-1.5,0.5-2.5v-12.9h4.3v12.9 c0,1.5-0.2,2.8-0.7,3.9c-0.5,1.1-1.1,1.9-1.9,2.6c-0.8,0.7-1.7,1.2-2.8,1.5C593.3,249,592.2,249.2,591.1,249.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M604.2,248.8v-21h4l7.9,11.5c0.1,0.2,0.2,0.4,0.4,0.7c0.2,0.3,0.3,0.6,0.4,0.8c0-0.2-0.1-0.5-0.1-0.8 c0-0.3,0-0.6,0-0.8v-11.5h4.3v21h-3.8l-8.1-11.6c-0.1-0.2-0.3-0.4-0.4-0.7c-0.2-0.3-0.3-0.6-0.4-0.9c0,0.3,0.1,0.5,0.1,0.8 c0,0.3,0,0.5,0,0.8v11.6H604.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M625.8,248.8v-21h7.5c1.8,0,3.4,0.3,4.7,0.9c1.3,0.6,2.3,1.4,3.2,2.4c0.8,1,1.4,2.1,1.8,3.4s0.6,2.5,0.6,3.8 c0,1.2-0.2,2.4-0.5,3.6c-0.4,1.2-0.9,2.4-1.7,3.4s-1.8,1.9-3.2,2.5c-1.3,0.6-2.9,1-4.9,1H625.8z M630.2,244.7h3.5 c1,0,1.8-0.2,2.5-0.6c0.7-0.4,1.2-0.9,1.7-1.5c0.4-0.6,0.7-1.3,0.9-2.1c0.2-0.8,0.3-1.5,0.3-2.2c0-0.8-0.1-1.5-0.3-2.3 c-0.2-0.8-0.5-1.4-0.9-2.1s-0.9-1.1-1.6-1.5c-0.6-0.4-1.4-0.6-2.3-0.6h-3.8V244.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M649.3,249.2c-0.7,0-1.4-0.2-1.9-0.7s-0.7-1.1-0.7-1.8c0-0.7,0.2-1.3,0.7-1.8c0.5-0.5,1.1-0.8,1.9-0.8 s1.4,0.3,1.9,0.8c0.5,0.5,0.8,1.1,0.8,1.8c0,0.7-0.3,1.3-0.8,1.8C650.6,248.9,650,249.2,649.3,249.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataNotFound);
export default __webpack_public_path__ + "static/media/data-not-found.0b62a328a923e476a80ffcb57771ff1f.svg";
export { ForwardRef as ReactComponent };